var items = {
  "block.minecraft.acacia_button": "زر السنط",
  "block.minecraft.acacia_door": "باب السنط",
  "block.minecraft.acacia_fence": "سياج السنط",
  "block.minecraft.acacia_fence_gate": "بوابة سياج السنط",
  "block.minecraft.acacia_hanging_sign": "لافتة السنط المعلقة",
  "block.minecraft.acacia_leaves": "أوراق السنط",
  "block.minecraft.acacia_log": "جذع السنط",
  "block.minecraft.acacia_planks": "ألواح خشب السنط",
  "block.minecraft.acacia_pressure_plate": "صفيحة ضغط خشب السنط",
  "block.minecraft.acacia_sapling": "شتلة السنط",
  "block.minecraft.acacia_shelf": "رف السنط",
  "block.minecraft.acacia_sign": "لافتة من السنط",
  "block.minecraft.acacia_slab": "بلاطة السنط",
  "block.minecraft.acacia_stairs": "درج السنط",
  "block.minecraft.acacia_trapdoor": "باب أرضي من خشب السنط",
  "block.minecraft.acacia_wall_hanging_sign": "لافتة جدارية من السنط معلقة",
  "block.minecraft.acacia_wall_sign": "لافتة جدارية من السنط",
  "block.minecraft.acacia_wood": "خشب السنط",
  "block.minecraft.activator_rail": "سكة حديدية مفعِّلة",
  "block.minecraft.air": "هواء",
  "block.minecraft.allium": "زهرة الثوم",
  "block.minecraft.amethyst_block": "كتلة من الأماثيست",
  "block.minecraft.amethyst_cluster": "تجمع أماثيست",
  "block.minecraft.ancient_debris": "حطام قديم",
  "block.minecraft.andesite": "أنديسايت",
  "block.minecraft.andesite_slab": "بلاطة أنديسايت",
  "block.minecraft.andesite_stairs": "درج أنديسايت",
  "block.minecraft.andesite_wall": "جدار أنديسايت",
  "block.minecraft.anvil": "سندان",
  "block.minecraft.attached_melon_stem": "جذع بطيخ موصول",
  "block.minecraft.attached_pumpkin_stem": "جذع يقطين موصول",
  "block.minecraft.azalea": "أزاليا",
  "block.minecraft.azalea_leaves": "أوراق الأزاليا",
  "block.minecraft.azure_bluet": "زهرة اللازوردية الزرقاء",
  "block.minecraft.bamboo": "قصب الخيزران",
  "block.minecraft.bamboo_block": "كتلة من الخيزران",
  "block.minecraft.bamboo_button": "زر الخيزران",
  "block.minecraft.bamboo_door": "باب الخيزران",
  "block.minecraft.bamboo_fence": "سياج من الخيزران",
  "block.minecraft.bamboo_fence_gate": "بوابة سياج من الخيزران",
  "block.minecraft.bamboo_hanging_sign": "لافتة خيزران معلقة",
  "block.minecraft.bamboo_mosaic": "فسيفساء الخيزران",
  "block.minecraft.bamboo_mosaic_slab": "بلاطة خيزران الفسيفساء",
  "block.minecraft.bamboo_mosaic_stairs": "سرعة تمرير البانوراما",
  "block.minecraft.bamboo_planks": "ألواح الخيزران",
  "block.minecraft.bamboo_pressure_plate": "صفيحة ضغط خشب الخيزران",
  "block.minecraft.bamboo_sapling": "بتيلة خيزران",
  "block.minecraft.bamboo_shelf": "رف الخيزران",
  "block.minecraft.bamboo_sign": "لافتة من الخيزران",
  "block.minecraft.bamboo_slab": "بلاطة خيزران",
  "block.minecraft.bamboo_stairs": "درج من الخيزران",
  "block.minecraft.bamboo_trapdoor": "باب أرضي من الخيزران",
  "block.minecraft.bamboo_wall_hanging_sign": "لافتة جدارية من الخيزران معلقة",
  "block.minecraft.bamboo_wall_sign": "لافتة جدران من الخيزران",
  "block.minecraft.banner.base.black": "حقل أسود كامل",
  "block.minecraft.banner.base.blue": "حقل أزرق كامل",
  "block.minecraft.banner.base.brown": "حقل بني كامل",
  "block.minecraft.banner.base.cyan": "حقل سماوي كامل",
  "block.minecraft.banner.base.gray": "حقل رمادي كامل",
  "block.minecraft.banner.base.green": "حقل أخضر كامل",
  "block.minecraft.banner.base.light_blue": "حقل أزرق فاتح كامل",
  "block.minecraft.banner.base.light_gray": "حقل رمادي فاتح كامل",
  "block.minecraft.banner.base.lime": "حقل أخضر فاتح كامل",
  "block.minecraft.banner.base.magenta": "لوح أرجواني كامل",
  "block.minecraft.banner.base.orange": "حقل برتقالي كامل",
  "block.minecraft.banner.base.pink": "حقل وردي كامل",
  "block.minecraft.banner.base.purple": "لوح بنفسجي كامل",
  "block.minecraft.banner.base.red": "حقل أحمر كامل",
  "block.minecraft.banner.base.white": "حقل أبيض كامل",
  "block.minecraft.banner.base.yellow": "حقل أصفر كامل",
  "block.minecraft.banner.border.black": "أسود الحواف",
  "block.minecraft.banner.border.blue": "أزرق الحواف",
  "block.minecraft.banner.border.brown": "بني الحواف",
  "block.minecraft.banner.border.cyan": "سماوي الحواف",
  "block.minecraft.banner.border.gray": "رمادي الحواف",
  "block.minecraft.banner.border.green": "أخضر الحواف",
  "block.minecraft.banner.border.light_blue": "أزرق فاتح الحواف",
  "block.minecraft.banner.border.light_gray": "رمادي فاتح الحواف",
  "block.minecraft.banner.border.lime": "ليموني الحواف",
  "block.minecraft.banner.border.magenta": "أرجواني الحواف",
  "block.minecraft.banner.border.orange": "برتقالي الحواف",
  "block.minecraft.banner.border.pink": "وردي الحواف",
  "block.minecraft.banner.border.purple": "بنفسجي الحواف",
  "block.minecraft.banner.border.red": "أحمر الحواف",
  "block.minecraft.banner.border.white": "أبيض الحواف",
  "block.minecraft.banner.border.yellow": "أصفر الحواف",
  "block.minecraft.banner.bricks.black": "شكل قالب طوب أسود",
  "block.minecraft.banner.bricks.blue": "شكل قالب طوب أزرق",
  "block.minecraft.banner.bricks.brown": "شكل قالب طوب بني",
  "block.minecraft.banner.bricks.cyan": "شكل قالب طوب سماوي",
  "block.minecraft.banner.bricks.gray": "شكل قالب طوب رمادي",
  "block.minecraft.banner.bricks.green": "شكل قالب طوب أخضر",
  "block.minecraft.banner.bricks.light_blue": "شكل قالب طوب أزرق فاتح",
  "block.minecraft.banner.bricks.light_gray": "شكل قالب طوب رمادي فاتح",
  "block.minecraft.banner.bricks.lime": "شكل قالب طوب ليموني",
  "block.minecraft.banner.bricks.magenta": "شكل قالب طوب أرجواني",
  "block.minecraft.banner.bricks.orange": "شكل قالب طوب برتقالي",
  "block.minecraft.banner.bricks.pink": "شكل قالب طوب وردي",
  "block.minecraft.banner.bricks.purple": "شكل قالب طوب بنفسجي",
  "block.minecraft.banner.bricks.red": "شكل قالب طوب أحمر",
  "block.minecraft.banner.bricks.white": "شكل قالب طوب أبيض",
  "block.minecraft.banner.bricks.yellow": "شكل قالب طوب أصفر",
  "block.minecraft.banner.circle.black": "دائرة سوداء",
  "block.minecraft.banner.circle.blue": "دائرة زرقاء",
  "block.minecraft.banner.circle.brown": "دائرة بنية",
  "block.minecraft.banner.circle.cyan": "دائرة سماوية",
  "block.minecraft.banner.circle.gray": "دائرة رمادية",
  "block.minecraft.banner.circle.green": "دائرة خضراء",
  "block.minecraft.banner.circle.light_blue": "دائرة زرقاء فاتحة",
  "block.minecraft.banner.circle.light_gray": "دائرة رمادية فاتحة",
  "block.minecraft.banner.circle.lime": "دائرة ليمونية",
  "block.minecraft.banner.circle.magenta": "دائرة أرجوانية",
  "block.minecraft.banner.circle.orange": "دائرة برتقالية",
  "block.minecraft.banner.circle.pink": "دائرة وردية",
  "block.minecraft.banner.circle.purple": "دائرة بنفسجية",
  "block.minecraft.banner.circle.red": "دائرة حمراء",
  "block.minecraft.banner.circle.white": "دائرة بيضاء",
  "block.minecraft.banner.circle.yellow": "دائرة صفراء",
  "block.minecraft.banner.creeper.black": "شعار كريبر اسود",
  "block.minecraft.banner.creeper.blue": "شعار كريبر أزرق",
  "block.minecraft.banner.creeper.brown": "شعار كريبر بني",
  "block.minecraft.banner.creeper.cyan": "شعار كريبر سماوي",
  "block.minecraft.banner.creeper.gray": "شعار كريبر رمادي",
  "block.minecraft.banner.creeper.green": "شعار كريبر اخضر",
  "block.minecraft.banner.creeper.light_blue": "شعار كريبر أزرق فاتح",
  "block.minecraft.banner.creeper.light_gray": "شعار كريبر رمادي فاتح",
  "block.minecraft.banner.creeper.lime": "شعار كريبر ليموني",
  "block.minecraft.banner.creeper.magenta": "شعار كريبر أرجواني",
  "block.minecraft.banner.creeper.orange": "شعار كريبر برتقالي",
  "block.minecraft.banner.creeper.pink": "شعار كريبر وردي",
  "block.minecraft.banner.creeper.purple": "شعار كريبر بنفسجي",
  "block.minecraft.banner.creeper.red": "شعار كريبر احمر",
  "block.minecraft.banner.creeper.white": "شعار كريبر أبيض",
  "block.minecraft.banner.creeper.yellow": "شعار كريبر أصفر",
  "block.minecraft.banner.cross.black": "شكل X أسود",
  "block.minecraft.banner.cross.blue": "شكل X أزرق",
  "block.minecraft.banner.cross.brown": "شكل X بني",
  "block.minecraft.banner.cross.cyan": "شكل X سماوي",
  "block.minecraft.banner.cross.gray": "شكل X رمادي",
  "block.minecraft.banner.cross.green": "شكل X أخصر",
  "block.minecraft.banner.cross.light_blue": "شكل X أزرق فاتح",
  "block.minecraft.banner.cross.light_gray": "شكل X رمادي فاتح",
  "block.minecraft.banner.cross.lime": "شكل X ليموني",
  "block.minecraft.banner.cross.magenta": "شكل X أرجواني",
  "block.minecraft.banner.cross.orange": "شكل X برتقالي",
  "block.minecraft.banner.cross.pink": "شكل X وردي",
  "block.minecraft.banner.cross.purple": "علامة X بنفسجية",
  "block.minecraft.banner.cross.red": "شكل X أحمر",
  "block.minecraft.banner.cross.white": "شكل X أبيض",
  "block.minecraft.banner.cross.yellow": "شكل X أصفر",
  "block.minecraft.banner.curly_border.black": "أسود مسنن الحواف",
  "block.minecraft.banner.curly_border.blue": "أزرق مسنن الحواف",
  "block.minecraft.banner.curly_border.brown": "بني مسنن الحواف",
  "block.minecraft.banner.curly_border.cyan": "سماوي مسنن الحواف",
  "block.minecraft.banner.curly_border.gray": "رمادي مسنن الحواف",
  "block.minecraft.banner.curly_border.green": "أخضر مسنن الحواف",
  "block.minecraft.banner.curly_border.light_blue": "أزرق فاتح مسنن الحواف",
  "block.minecraft.banner.curly_border.light_gray": "رمادي فاتح مسنن الحواف",
  "block.minecraft.banner.curly_border.lime": "ليموني مسنن الحواف",
  "block.minecraft.banner.curly_border.magenta": "أرجواني مسنن الحواف",
  "block.minecraft.banner.curly_border.orange": "برتقالي مسنن الحواف",
  "block.minecraft.banner.curly_border.pink": "وردي مسنن الحواف",
  "block.minecraft.banner.curly_border.purple": "بنفسجي مسنن الحواف",
  "block.minecraft.banner.curly_border.red": "أحمر مسنن الحواف",
  "block.minecraft.banner.curly_border.white": "أبيض مسنن الحواف",
  "block.minecraft.banner.curly_border.yellow": "أصفر مسنن الحواف",
  "block.minecraft.banner.diagonal_left.black": "النصف العلوي الأيسر أسود",
  "block.minecraft.banner.diagonal_left.blue": "النصف العلوي الأيسر أزرق",
  "block.minecraft.banner.diagonal_left.brown": "النصف العلوي الأيسر بني",
  "block.minecraft.banner.diagonal_left.cyan": "النصف العلوي الأيسر سماوي",
  "block.minecraft.banner.diagonal_left.gray": "النصف العلوي الأيسر رمادي",
  "block.minecraft.banner.diagonal_left.green": "النصف العلوي الأيسر أخضر",
  "block.minecraft.banner.diagonal_left.light_blue": "النصف العلوي الأيسر أزرق فاتح",
  "block.minecraft.banner.diagonal_left.light_gray": "النصف العلوي الأيسر رمادي فاتح",
  "block.minecraft.banner.diagonal_left.lime": "النصف العلوي الأيسر ليموني",
  "block.minecraft.banner.diagonal_left.magenta": "النصف العلوي الأيسر أرجواني",
  "block.minecraft.banner.diagonal_left.orange": "النصف العلوي الأيسر برتقالي",
  "block.minecraft.banner.diagonal_left.pink": "النصف العلوي الأيسر وردي",
  "block.minecraft.banner.diagonal_left.purple": "النصف العلوي الأيسر بنفسجي",
  "block.minecraft.banner.diagonal_left.red": "النصف العلوي الأيسر أحمر",
  "block.minecraft.banner.diagonal_left.white": "النصف العلوي الأيسر أبيض",
  "block.minecraft.banner.diagonal_left.yellow": "النصف العلوي الأيسر أصفر",
  "block.minecraft.banner.diagonal_right.black": "النصف العلوي الأيمن أسود",
  "block.minecraft.banner.diagonal_right.blue": "النصف العلوي الأيمن أزرق",
  "block.minecraft.banner.diagonal_right.brown": "النصف العلوي الأيمن بني",
  "block.minecraft.banner.diagonal_right.cyan": "النصف العلوي الأيمن سماوي",
  "block.minecraft.banner.diagonal_right.gray": "النصف العلوي الأيمن رمادي",
  "block.minecraft.banner.diagonal_right.green": "النصف العلوي الأيمن أخضر",
  "block.minecraft.banner.diagonal_right.light_blue": "النصف العلوي الأيمن أزرق فاتح",
  "block.minecraft.banner.diagonal_right.light_gray": "النصف العلوي الأيمن رمادي فاتح",
  "block.minecraft.banner.diagonal_right.lime": "النصف العلوي الأيمن ليموني",
  "block.minecraft.banner.diagonal_right.magenta": "النصف العلوي الأيمن أرجواني",
  "block.minecraft.banner.diagonal_right.orange": "النصف العلوي الأيمن برتقالي",
  "block.minecraft.banner.diagonal_right.pink": "النصف العلوي الأيمن وردي",
  "block.minecraft.banner.diagonal_right.purple": "النصف العلوي الأيمن بنفسجي",
  "block.minecraft.banner.diagonal_right.red": "النصف العلوي الأيمن أحمر",
  "block.minecraft.banner.diagonal_right.white": "النصف العلوي الأيمن أبيض",
  "block.minecraft.banner.diagonal_right.yellow": "النصف العلوي الأيمن أصفر",
  "block.minecraft.banner.diagonal_up_left.black": "النصف السفلي الأيسر أسود",
  "block.minecraft.banner.diagonal_up_left.blue": "النصف السفلي الأيسر أزرق",
  "block.minecraft.banner.diagonal_up_left.brown": "النصف السفلي الأيسر بني",
  "block.minecraft.banner.diagonal_up_left.cyan": "النصف السفلي الأيسر سماوي",
  "block.minecraft.banner.diagonal_up_left.gray": "النصف السفلي الأيسر رمادي",
  "block.minecraft.banner.diagonal_up_left.green": "النصف السفلي الأيسر أخضر",
  "block.minecraft.banner.diagonal_up_left.light_blue": "النصف السفلي الأيسر أزرق فاتح",
  "block.minecraft.banner.diagonal_up_left.light_gray": "النصف السفلي الأيسر رمادي فاتح",
  "block.minecraft.banner.diagonal_up_left.lime": "النصف السفلي الأيسر ليموني",
  "block.minecraft.banner.diagonal_up_left.magenta": "النصف السفلي الأيسر أرجواني",
  "block.minecraft.banner.diagonal_up_left.orange": "النصف السفلي الأيسر برتقالي",
  "block.minecraft.banner.diagonal_up_left.pink": "النصف السفلي الأيسر وردي",
  "block.minecraft.banner.diagonal_up_left.purple": "النصف السفلي الأيسر بنفسجي",
  "block.minecraft.banner.diagonal_up_left.red": "النصف السفلي الأيسر أحمر",
  "block.minecraft.banner.diagonal_up_left.white": "النصف السفلي الأيسر أبيض",
  "block.minecraft.banner.diagonal_up_left.yellow": "النصف السفلي الأيسر أصفر",
  "block.minecraft.banner.diagonal_up_right.black": "النصف السفلي الأيمن أسود",
  "block.minecraft.banner.diagonal_up_right.blue": "النصف السفلي الأيمن أزرق",
  "block.minecraft.banner.diagonal_up_right.brown": "النصف السفلي الأيمن بني",
  "block.minecraft.banner.diagonal_up_right.cyan": "النصف السفلي الأيمن سماوي",
  "block.minecraft.banner.diagonal_up_right.gray": "النصف السفلي الأيمن رمادي",
  "block.minecraft.banner.diagonal_up_right.green": "النصف السفلي الأيمن أخضر",
  "block.minecraft.banner.diagonal_up_right.light_blue": "النصف السفلي الأيمن أزرق فاتح",
  "block.minecraft.banner.diagonal_up_right.light_gray": "النصف السفلي الأيمن رمادي فاتح",
  "block.minecraft.banner.diagonal_up_right.lime": "النصف السفلي الأيمن ليموني",
  "block.minecraft.banner.diagonal_up_right.magenta": "النصف السفلي الأيمن أرجواني",
  "block.minecraft.banner.diagonal_up_right.orange": "النصف السفلي الأيمن برتقالي",
  "block.minecraft.banner.diagonal_up_right.pink": "النصف السفلي الأيمن وردي",
  "block.minecraft.banner.diagonal_up_right.purple": "النصف السفلي الأيمن بنفسجي",
  "block.minecraft.banner.diagonal_up_right.red": "النصف السفلي الأيمن أحمر",
  "block.minecraft.banner.diagonal_up_right.white": "النصف السفلي الأيمن أبيض",
  "block.minecraft.banner.diagonal_up_right.yellow": "النصف السفلي الأيمن أصفر",
  "block.minecraft.banner.flow.black": "التدفق الأسود",
  "block.minecraft.banner.flow.blue": "التدفق الأزرق",
  "block.minecraft.banner.flow.brown": "التدفق البني",
  "block.minecraft.banner.flow.cyan": "تدفق سماوي",
  "block.minecraft.banner.flow.gray": "التدفق الرمادي",
  "block.minecraft.banner.flow.green": "التدفق الأخضر",
  "block.minecraft.banner.flow.light_blue": "تدفق الأزرق فاتحة",
  "block.minecraft.banner.flow.light_gray": "تدفق رمادي فاتح",
  "block.minecraft.banner.flow.lime": "تدفق الأخضر",
  "block.minecraft.banner.flow.magenta": "تدفق أرجواني",
  "block.minecraft.banner.flow.orange": "التدفق البرتقالي",
  "block.minecraft.banner.flow.pink": "التدفق الوردي",
  "block.minecraft.banner.flow.purple": "التدفق الأرجواني",
  "block.minecraft.banner.flow.red": "التدفق الأحمر",
  "block.minecraft.banner.flow.white": "التدفق الأبيض",
  "block.minecraft.banner.flow.yellow": "التدفق الأصفر",
  "block.minecraft.banner.flower.black": "شعار زهرة أسود",
  "block.minecraft.banner.flower.blue": "شعار زهرة أزرق",
  "block.minecraft.banner.flower.brown": "شعار زهرة بني",
  "block.minecraft.banner.flower.cyan": "شعار زهرة سماوي",
  "block.minecraft.banner.flower.gray": "شعار زهرة رمادي",
  "block.minecraft.banner.flower.green": "شعار زهرة أخضر",
  "block.minecraft.banner.flower.light_blue": "شعار زهرة أزرق فاتح",
  "block.minecraft.banner.flower.light_gray": "شعار زهرة رمادي فاتح",
  "block.minecraft.banner.flower.lime": "شعار زهرة ليموني",
  "block.minecraft.banner.flower.magenta": "شعار زهرة أرجواني",
  "block.minecraft.banner.flower.orange": "شعار زهرة برتقالي",
  "block.minecraft.banner.flower.pink": "شعار زهرة وردي",
  "block.minecraft.banner.flower.purple": "شعار زهرة بنفسجي",
  "block.minecraft.banner.flower.red": "شعار زهرة أحمر",
  "block.minecraft.banner.flower.white": "شعار زهرة أبيض",
  "block.minecraft.banner.flower.yellow": "شعار زهرة أصفر",
  "block.minecraft.banner.globe.black": "كرة أرضية سوداء",
  "block.minecraft.banner.globe.blue": "كرة أرضية زرقاء",
  "block.minecraft.banner.globe.brown": "كرة أرضية بنية",
  "block.minecraft.banner.globe.cyan": "كرة أرضية سماوية",
  "block.minecraft.banner.globe.gray": "كرة أرضية رمادية",
  "block.minecraft.banner.globe.green": "كرة أرضية خضراء",
  "block.minecraft.banner.globe.light_blue": "كرة أرضية زرقاء فاتحة",
  "block.minecraft.banner.globe.light_gray": "كرة أرضية رمادية فاتحة",
  "block.minecraft.banner.globe.lime": "كرة أرضية خضراء",
  "block.minecraft.banner.globe.magenta": "كرة أرضية أرجوانية",
  "block.minecraft.banner.globe.orange": "كرة أرضية برتقالية",
  "block.minecraft.banner.globe.pink": "كرة أرضية وردية",
  "block.minecraft.banner.globe.purple": "كرة أرضية بنفسجية",
  "block.minecraft.banner.globe.red": "كرة أرضية حمراء",
  "block.minecraft.banner.globe.white": "كرة أرضية بيضاء",
  "block.minecraft.banner.globe.yellow": "كرة أرضية صفراء",
  "block.minecraft.banner.gradient.black": "تدرج أسود",
  "block.minecraft.banner.gradient.blue": "تدرج أزرق",
  "block.minecraft.banner.gradient.brown": "تدرج بني",
  "block.minecraft.banner.gradient.cyan": "تدرج سماوي",
  "block.minecraft.banner.gradient.gray": "تدرج رمادي",
  "block.minecraft.banner.gradient.green": "تدرج أخضر",
  "block.minecraft.banner.gradient.light_blue": "تدرج أزرق فاتح",
  "block.minecraft.banner.gradient.light_gray": "تدرج رمادي فاتح",
  "block.minecraft.banner.gradient.lime": "تدرج ليموني",
  "block.minecraft.banner.gradient.magenta": "تدرج أرجواني",
  "block.minecraft.banner.gradient.orange": "تدرج برتقالي",
  "block.minecraft.banner.gradient.pink": "تدرج وردي",
  "block.minecraft.banner.gradient.purple": "تدرج بنفسجي",
  "block.minecraft.banner.gradient.red": "تدرج أحمر",
  "block.minecraft.banner.gradient.white": "تدرج أبيض",
  "block.minecraft.banner.gradient.yellow": "تدرج أصفر",
  "block.minecraft.banner.gradient_up.black": "تدرج من الأسفل أسود",
  "block.minecraft.banner.gradient_up.blue": "تدرج من الأسفل أزرق",
  "block.minecraft.banner.gradient_up.brown": "تدرج من الأسفل بني",
  "block.minecraft.banner.gradient_up.cyan": "تدرج من الأسفل سماوي",
  "block.minecraft.banner.gradient_up.gray": "تدرج من الأسفل رمادي",
  "block.minecraft.banner.gradient_up.green": "تدرج من الأسفل أخضر",
  "block.minecraft.banner.gradient_up.light_blue": "تدرج من الأسفل أزرق فاتح",
  "block.minecraft.banner.gradient_up.light_gray": "تدرج من الأسفل رمادي فاتح",
  "block.minecraft.banner.gradient_up.lime": "تدرج من الأسفل ليموني",
  "block.minecraft.banner.gradient_up.magenta": "تدرج من الأسفل أرجواني",
  "block.minecraft.banner.gradient_up.orange": "تدرج من الأسفل برتقالي",
  "block.minecraft.banner.gradient_up.pink": "تدرج من الأسفل وردي",
  "block.minecraft.banner.gradient_up.purple": "تدرج من الأسفل بنفسجي",
  "block.minecraft.banner.gradient_up.red": "تدرج من الأسفل أحمر",
  "block.minecraft.banner.gradient_up.white": "تدرج من الأسفل أبيض",
  "block.minecraft.banner.gradient_up.yellow": "تدرج من الأسفل أصفر",
  "block.minecraft.banner.guster.black": "غاستر اللأسود",
  "block.minecraft.banner.guster.blue": "غاستر اللأزرق",
  "block.minecraft.banner.guster.brown": "جاستر البني",
  "block.minecraft.banner.guster.cyan": "غاستر أزرق سماوي",
  "block.minecraft.banner.guster.gray": "غاستر الرمادي",
  "block.minecraft.banner.guster.green": "غاستر الأخضر",
  "block.minecraft.banner.guster.light_blue": "جاستر زرقاء فاتحة",
  "block.minecraft.banner.guster.light_gray": "غاستر رمادي فاتحه",
  "block.minecraft.banner.guster.lime": "غاستر الخضراء",
  "block.minecraft.banner.guster.magenta": "جاستر ارجوانية",
  "block.minecraft.banner.guster.orange": "جاستر البرتقالي",
  "block.minecraft.banner.guster.pink": "غاستر الزهري",
  "block.minecraft.banner.guster.purple": "جاستر الأرجواني",
  "block.minecraft.banner.guster.red": "جاستر الأحمر",
  "block.minecraft.banner.guster.white": "غاستر الأبيض",
  "block.minecraft.banner.guster.yellow": "جاستر الأصفر",
  "block.minecraft.banner.half_horizontal.black": "النصف الأعلى ملون أسود",
  "block.minecraft.banner.half_horizontal.blue": "النصف الأعلى ملون أزرق",
  "block.minecraft.banner.half_horizontal.brown": "النصف الأعلى ملون بني",
  "block.minecraft.banner.half_horizontal.cyan": "النصف الأعلى ملون سماوي",
  "block.minecraft.banner.half_horizontal.gray": "النصف الأعلى ملون رمادي",
  "block.minecraft.banner.half_horizontal.green": "النصف الأعلى ملون أخضر",
  "block.minecraft.banner.half_horizontal.light_blue": "النصف الأعلى ملون أزرق فاتح",
  "block.minecraft.banner.half_horizontal.light_gray": "النصف الأعلى ملون رمادي فاتح",
  "block.minecraft.banner.half_horizontal.lime": "النصف الأعلى ملون ليموني",
  "block.minecraft.banner.half_horizontal.magenta": "النصف الأعلى ملون أرجواني",
  "block.minecraft.banner.half_horizontal.orange": "النصف الأعلى ملون برتقالي",
  "block.minecraft.banner.half_horizontal.pink": "النصف الأعلى ملون وردي",
  "block.minecraft.banner.half_horizontal.purple": "النصف الأعلى ملون بنفسجي",
  "block.minecraft.banner.half_horizontal.red": "النصف الأعلى ملون أحمر",
  "block.minecraft.banner.half_horizontal.white": "النصف الأعلى ملون أبيض",
  "block.minecraft.banner.half_horizontal.yellow": "النصف الأعلى ملون أصفر",
  "block.minecraft.banner.half_horizontal_bottom.black": "النصف الأسفل ملون أسود",
  "block.minecraft.banner.half_horizontal_bottom.blue": "النصف الأسفل ملون أزرق",
  "block.minecraft.banner.half_horizontal_bottom.brown": "النصف الأسفل ملون بني",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "النصف الأسفل ملون سماوي",
  "block.minecraft.banner.half_horizontal_bottom.gray": "النصف الأسفل ملون رمادي",
  "block.minecraft.banner.half_horizontal_bottom.green": "النصف الأسفل ملون أخضر",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "النصف الأسفل ملون أزرق فاتح",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "النصف الأسفل ملون رمادي فاتح",
  "block.minecraft.banner.half_horizontal_bottom.lime": "النصف الأسفل ملون ليموني",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "النصف الأسفل ملون أرجواني",
  "block.minecraft.banner.half_horizontal_bottom.orange": "النصف الأسفل ملون برتقالي",
  "block.minecraft.banner.half_horizontal_bottom.pink": "النصف الأسفل ملون وردي",
  "block.minecraft.banner.half_horizontal_bottom.purple": "النصف الأسفل ملون بنفسجي",
  "block.minecraft.banner.half_horizontal_bottom.red": "النصف الأسفل ملون أحمر",
  "block.minecraft.banner.half_horizontal_bottom.white": "النصف الأسفل ملون أبيض",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "النصف الأسفل ملون أصفر",
  "block.minecraft.banner.half_vertical.black": "النصف اليساري ملون أسود",
  "block.minecraft.banner.half_vertical.blue": "النصف اليساري ملون أزرق",
  "block.minecraft.banner.half_vertical.brown": "النصف اليساري ملون بني",
  "block.minecraft.banner.half_vertical.cyan": "النصف اليساري ملون سماوي",
  "block.minecraft.banner.half_vertical.gray": "النصف اليساري ملون رمادي",
  "block.minecraft.banner.half_vertical.green": "النصف اليساري ملون أخضر",
  "block.minecraft.banner.half_vertical.light_blue": "النصف اليساري ملون أزرق فاتح",
  "block.minecraft.banner.half_vertical.light_gray": "النصف اليساري ملون رمادي فاتح",
  "block.minecraft.banner.half_vertical.lime": "النصف اليساري ملون ليموني",
  "block.minecraft.banner.half_vertical.magenta": "النصف اليساري ملون أرجواني",
  "block.minecraft.banner.half_vertical.orange": "النصف اليساري ملون برتقالي",
  "block.minecraft.banner.half_vertical.pink": "النصف اليساري ملون وردي",
  "block.minecraft.banner.half_vertical.purple": "النصف اليساري ملون بنفسجي",
  "block.minecraft.banner.half_vertical.red": "النصف اليساري ملون أحمر",
  "block.minecraft.banner.half_vertical.white": "النصف اليساري ملون أبيض",
  "block.minecraft.banner.half_vertical.yellow": "النصف اليساري ملون أصفر",
  "block.minecraft.banner.half_vertical_right.black": "النصف اليميني ملون أسود",
  "block.minecraft.banner.half_vertical_right.blue": "النصف اليميني ملون أزرق",
  "block.minecraft.banner.half_vertical_right.brown": "النصف اليميني ملون بني",
  "block.minecraft.banner.half_vertical_right.cyan": "النصف اليميني ملون سماوي",
  "block.minecraft.banner.half_vertical_right.gray": "النصف اليميني ملون رمادي",
  "block.minecraft.banner.half_vertical_right.green": "النصف اليميني ملون أخضر",
  "block.minecraft.banner.half_vertical_right.light_blue": "النصف اليميني ملون أزرق فاتح",
  "block.minecraft.banner.half_vertical_right.light_gray": "النصف اليميني ملون رمادي فاتح",
  "block.minecraft.banner.half_vertical_right.lime": "النصف اليميني ملون ليموني",
  "block.minecraft.banner.half_vertical_right.magenta": "النصف اليميني ملون أرجواني",
  "block.minecraft.banner.half_vertical_right.orange": "النصف اليميني ملون برتقالي",
  "block.minecraft.banner.half_vertical_right.pink": "النصف اليميني ملون وردي",
  "block.minecraft.banner.half_vertical_right.purple": "النصف اليميني ملون بنفسجي",
  "block.minecraft.banner.half_vertical_right.red": "النصف اليميني ملون أحمر",
  "block.minecraft.banner.half_vertical_right.white": "النصف اليميني ملون أبيض",
  "block.minecraft.banner.half_vertical_right.yellow": "النصف اليميني ملون أصفر",
  "block.minecraft.banner.mojang.black": "شيء أسود",
  "block.minecraft.banner.mojang.blue": "شيء أزرق",
  "block.minecraft.banner.mojang.brown": "شيء بني",
  "block.minecraft.banner.mojang.cyan": "شيء سماوي",
  "block.minecraft.banner.mojang.gray": "شيء رمادي",
  "block.minecraft.banner.mojang.green": "شيء أخضر",
  "block.minecraft.banner.mojang.light_blue": "شيء أزرق فاتح",
  "block.minecraft.banner.mojang.light_gray": "شيء رمادي فاتح",
  "block.minecraft.banner.mojang.lime": "شيء ليموني",
  "block.minecraft.banner.mojang.magenta": "شيء أرجواني",
  "block.minecraft.banner.mojang.orange": "شيء برتقالي",
  "block.minecraft.banner.mojang.pink": "شيء وردي",
  "block.minecraft.banner.mojang.purple": "شيء بنفسجي",
  "block.minecraft.banner.mojang.red": "شيء أحمر",
  "block.minecraft.banner.mojang.white": "شيء أبيض",
  "block.minecraft.banner.mojang.yellow": "شيء أصفر",
  "block.minecraft.banner.piglin.black": "أنف أسود",
  "block.minecraft.banner.piglin.blue": "أنف أزرق",
  "block.minecraft.banner.piglin.brown": "أنف بني",
  "block.minecraft.banner.piglin.cyan": "أنف سماوي",
  "block.minecraft.banner.piglin.gray": "أنف رمادي",
  "block.minecraft.banner.piglin.green": "أنف أخضر",
  "block.minecraft.banner.piglin.light_blue": "أنف أزرق فاتح",
  "block.minecraft.banner.piglin.light_gray": "أنف رمادي فاتح",
  "block.minecraft.banner.piglin.lime": "أنف أخضر فاتح",
  "block.minecraft.banner.piglin.magenta": "أنف أرجواني",
  "block.minecraft.banner.piglin.orange": "أنف برتقالي",
  "block.minecraft.banner.piglin.pink": "أنف وردي",
  "block.minecraft.banner.piglin.purple": "أنف بنفسجي",
  "block.minecraft.banner.piglin.red": "أنف أحمر",
  "block.minecraft.banner.piglin.white": "أنف أبيض",
  "block.minecraft.banner.piglin.yellow": "أنف أصفر",
  "block.minecraft.banner.rhombus.black": "معين أسود",
  "block.minecraft.banner.rhombus.blue": "معين أزرق",
  "block.minecraft.banner.rhombus.brown": "معين بني",
  "block.minecraft.banner.rhombus.cyan": "معين سماوي",
  "block.minecraft.banner.rhombus.gray": "معين رمادي",
  "block.minecraft.banner.rhombus.green": "معين أخضر",
  "block.minecraft.banner.rhombus.light_blue": "معين أزرق فاتح",
  "block.minecraft.banner.rhombus.light_gray": "معين رمادي فاتح",
  "block.minecraft.banner.rhombus.lime": "معين ليموني",
  "block.minecraft.banner.rhombus.magenta": "معين أرجواني",
  "block.minecraft.banner.rhombus.orange": "معين برتقالي",
  "block.minecraft.banner.rhombus.pink": "معين وردي",
  "block.minecraft.banner.rhombus.purple": "معين بنفسجي",
  "block.minecraft.banner.rhombus.red": "معين أحمر",
  "block.minecraft.banner.rhombus.white": "معين أبيض",
  "block.minecraft.banner.rhombus.yellow": "معين أصفر",
  "block.minecraft.banner.skull.black": "شعار جمجمة أسود",
  "block.minecraft.banner.skull.blue": "شعار جمجمة أزرق",
  "block.minecraft.banner.skull.brown": "شعار جمجمة بني",
  "block.minecraft.banner.skull.cyan": "شعار جمجمة سماوي",
  "block.minecraft.banner.skull.gray": "شعار جمجمة رمادي",
  "block.minecraft.banner.skull.green": "شعار جمجمة أخضر",
  "block.minecraft.banner.skull.light_blue": "شعار جمجمة أزرق فاتح",
  "block.minecraft.banner.skull.light_gray": "شعار جمجمة رمادي فاتح",
  "block.minecraft.banner.skull.lime": "شعار جمجمة أخضر فاتح",
  "block.minecraft.banner.skull.magenta": "شعار جمجمة أرجواني",
  "block.minecraft.banner.skull.orange": "شعار جمجمة برتقالي",
  "block.minecraft.banner.skull.pink": "شعار جمجمة وردي",
  "block.minecraft.banner.skull.purple": "شعار جمجمة بنفسجي",
  "block.minecraft.banner.skull.red": "شعار جمجمة أحمر",
  "block.minecraft.banner.skull.white": "شعار جمجمة أبيض",
  "block.minecraft.banner.skull.yellow": "شعار جمجمة أصفر",
  "block.minecraft.banner.small_stripes.black": "خطوط صغيرة سوداء",
  "block.minecraft.banner.small_stripes.blue": "خطوط صغيرة زرقاء",
  "block.minecraft.banner.small_stripes.brown": "خطوط صغيرة بنية",
  "block.minecraft.banner.small_stripes.cyan": "خطوط صغيرة سماوية",
  "block.minecraft.banner.small_stripes.gray": "خطوط صغيرة رمتدية",
  "block.minecraft.banner.small_stripes.green": "خطوط صغيرة خضراء",
  "block.minecraft.banner.small_stripes.light_blue": "خطوط صغيرة زرقاء فاتحة",
  "block.minecraft.banner.small_stripes.light_gray": "خطوط صغيرة رمادية فاتحة",
  "block.minecraft.banner.small_stripes.lime": "خطوط صغيرة ليمونية",
  "block.minecraft.banner.small_stripes.magenta": "خطوط صغيرة أرجوانية",
  "block.minecraft.banner.small_stripes.orange": "خطوط صغيرة برتقالية",
  "block.minecraft.banner.small_stripes.pink": "خطوط صغيرة وردية",
  "block.minecraft.banner.small_stripes.purple": "خطوط صغيرة بنفسجية",
  "block.minecraft.banner.small_stripes.red": "خطوط صغيرة حمراء",
  "block.minecraft.banner.small_stripes.white": "خطوط صغيرة بيضاء",
  "block.minecraft.banner.small_stripes.yellow": "خطوط صغيرة صفراء",
  "block.minecraft.banner.square_bottom_left.black": "مربع سفلي أيسر أسود",
  "block.minecraft.banner.square_bottom_left.blue": "مربع سفلي أيسر أزرق",
  "block.minecraft.banner.square_bottom_left.brown": "مربع سفلي أيسر بني",
  "block.minecraft.banner.square_bottom_left.cyan": "مربع سفلي أيسر سماوي",
  "block.minecraft.banner.square_bottom_left.gray": "مربع سفلي أيسر رمادي",
  "block.minecraft.banner.square_bottom_left.green": "مربع سفلي أيسر أخضر",
  "block.minecraft.banner.square_bottom_left.light_blue": "مربع سفلي أيسر أزرق فاتح",
  "block.minecraft.banner.square_bottom_left.light_gray": "مربع سفلي أيسر رمادي فاتح",
  "block.minecraft.banner.square_bottom_left.lime": "مربع سفلي أيسر ليموني",
  "block.minecraft.banner.square_bottom_left.magenta": "مربع سفلي أيسر أرجواني",
  "block.minecraft.banner.square_bottom_left.orange": "مربع سفلي أيسر برتقالي",
  "block.minecraft.banner.square_bottom_left.pink": "مربع سفلي أيسر وردي",
  "block.minecraft.banner.square_bottom_left.purple": "مربع سفلي أيسر بنفسجي",
  "block.minecraft.banner.square_bottom_left.red": "مربع سفلي أيسر أحمر",
  "block.minecraft.banner.square_bottom_left.white": "مربع سفلي أيسر أبيض",
  "block.minecraft.banner.square_bottom_left.yellow": "مربع سفلي أيسر أصفر",
  "block.minecraft.banner.square_bottom_right.black": "مربع سفلي أيمن أسود",
  "block.minecraft.banner.square_bottom_right.blue": "مربع سفلي أيمن أزرق",
  "block.minecraft.banner.square_bottom_right.brown": "مربع سفلي أيمن بني",
  "block.minecraft.banner.square_bottom_right.cyan": "مربع سفلي أيمن سماوي",
  "block.minecraft.banner.square_bottom_right.gray": "مربع سفلي أيمن رمادي",
  "block.minecraft.banner.square_bottom_right.green": "مربع سفلي أيمن أخضر",
  "block.minecraft.banner.square_bottom_right.light_blue": "مربع سفلي أيمن أزرق فاتح",
  "block.minecraft.banner.square_bottom_right.light_gray": "مربع سفلي أيمن رمادي فاتح",
  "block.minecraft.banner.square_bottom_right.lime": "مربع سفلي أيمن ليموني",
  "block.minecraft.banner.square_bottom_right.magenta": "مربع سفلي أيمن أرجواني",
  "block.minecraft.banner.square_bottom_right.orange": "مربع سفلي أيمن برتقالي",
  "block.minecraft.banner.square_bottom_right.pink": "مربع سفلي أيمن وردي",
  "block.minecraft.banner.square_bottom_right.purple": "مربع سفلي أيمن بنفسجي",
  "block.minecraft.banner.square_bottom_right.red": "مربع سفلي أيمن أحمر",
  "block.minecraft.banner.square_bottom_right.white": "مربع سفلي أيمن أبيض",
  "block.minecraft.banner.square_bottom_right.yellow": "مربع سفلي أيمن أصفر",
  "block.minecraft.banner.square_top_left.black": "مربع رأسي أيسر أسود",
  "block.minecraft.banner.square_top_left.blue": "مربع رأسي أيسر أزرق",
  "block.minecraft.banner.square_top_left.brown": "مربع رأسي أيسر بني",
  "block.minecraft.banner.square_top_left.cyan": "مربع رأسي أيسر سماوي",
  "block.minecraft.banner.square_top_left.gray": "مربع رأسي أيسر رمادي",
  "block.minecraft.banner.square_top_left.green": "مربع رأسي أيسر أخضر",
  "block.minecraft.banner.square_top_left.light_blue": "مربع رأسي أيسر أزرق فاتح",
  "block.minecraft.banner.square_top_left.light_gray": "مربع رأسي أيسر رمادي فاتح",
  "block.minecraft.banner.square_top_left.lime": "مربع رأسي أيسر ليموني",
  "block.minecraft.banner.square_top_left.magenta": "مربع رأسي أيسر أرجواني",
  "block.minecraft.banner.square_top_left.orange": "مربع رأسي أيسر برتقالي",
  "block.minecraft.banner.square_top_left.pink": "مربع رأسي أيسر وردي",
  "block.minecraft.banner.square_top_left.purple": "مربع رأسي أيسر بنفسجي",
  "block.minecraft.banner.square_top_left.red": "مربع رأسي أيسر أحمر",
  "block.minecraft.banner.square_top_left.white": "مربع رأسي أيسر أبيض",
  "block.minecraft.banner.square_top_left.yellow": "مربع رأسي أيسر أصفر",
  "block.minecraft.banner.square_top_right.black": "مربع رأسي أيمن أسود",
  "block.minecraft.banner.square_top_right.blue": "مربع رأسي أيمن أزرق",
  "block.minecraft.banner.square_top_right.brown": "مربع رأسي أيمن بني",
  "block.minecraft.banner.square_top_right.cyan": "مربع رأسي أيمن سماوي",
  "block.minecraft.banner.square_top_right.gray": "مربع رأسي أيمن وردي",
  "block.minecraft.banner.square_top_right.green": "مربع رأسي أيمن أخضر",
  "block.minecraft.banner.square_top_right.light_blue": "مربع رأسي أيمن أزرق فاتح",
  "block.minecraft.banner.square_top_right.light_gray": "مربع رأسي أيمن رمادي فاتح",
  "block.minecraft.banner.square_top_right.lime": "مربع رأسي أيمن ليموني",
  "block.minecraft.banner.square_top_right.magenta": "مربع رأسي أيمن أرجواني",
  "block.minecraft.banner.square_top_right.orange": "مربع رأسي أيمن برتقالي",
  "block.minecraft.banner.square_top_right.pink": "مربع رأسي أيمن وردي",
  "block.minecraft.banner.square_top_right.purple": "مربع رأسي أيمن بنفسجي",
  "block.minecraft.banner.square_top_right.red": "مربع رأسي أيمن أحمر",
  "block.minecraft.banner.square_top_right.white": "مربع رأسي أيمن أبيض",
  "block.minecraft.banner.square_top_right.yellow": "مربع رأسي أيمن أصفر",
  "block.minecraft.banner.straight_cross.black": "صليب أسود",
  "block.minecraft.banner.straight_cross.blue": "صليب أزرق",
  "block.minecraft.banner.straight_cross.brown": "صليب بني",
  "block.minecraft.banner.straight_cross.cyan": "صليب سماوي",
  "block.minecraft.banner.straight_cross.gray": "صليب رمادي",
  "block.minecraft.banner.straight_cross.green": "صليب أخضر",
  "block.minecraft.banner.straight_cross.light_blue": "صليب أزرق فاتح",
  "block.minecraft.banner.straight_cross.light_gray": "صليب رمادي فاتح",
  "block.minecraft.banner.straight_cross.lime": "صليب ليموني",
  "block.minecraft.banner.straight_cross.magenta": "صليب أرجواني",
  "block.minecraft.banner.straight_cross.orange": "صليب برتقالي",
  "block.minecraft.banner.straight_cross.pink": "صليب وردي",
  "block.minecraft.banner.straight_cross.purple": "صليب بنفسجي",
  "block.minecraft.banner.straight_cross.red": "صليب أحمر",
  "block.minecraft.banner.straight_cross.white": "صليب أبيض",
  "block.minecraft.banner.straight_cross.yellow": "صليب أصفر",
  "block.minecraft.banner.stripe_bottom.black": "شريط سفلي أسود",
  "block.minecraft.banner.stripe_bottom.blue": "شريط سفلي أزرق",
  "block.minecraft.banner.stripe_bottom.brown": "شريط سفلي بني",
  "block.minecraft.banner.stripe_bottom.cyan": "شريط سفلي سماوي",
  "block.minecraft.banner.stripe_bottom.gray": "شريط سفلي رمادي",
  "block.minecraft.banner.stripe_bottom.green": "شريط سفلي أخضر",
  "block.minecraft.banner.stripe_bottom.light_blue": "شريط سفلي أزرق فاتح",
  "block.minecraft.banner.stripe_bottom.light_gray": "شريط سفلي رمادي فاتح",
  "block.minecraft.banner.stripe_bottom.lime": "شريط سفلي ليموني",
  "block.minecraft.banner.stripe_bottom.magenta": "شريط سفلي أرجواني",
  "block.minecraft.banner.stripe_bottom.orange": "شريط سفلي برتقالي",
  "block.minecraft.banner.stripe_bottom.pink": "شريط سفلي وردي",
  "block.minecraft.banner.stripe_bottom.purple": "شريط سفلي بنفسجي",
  "block.minecraft.banner.stripe_bottom.red": "شريط سفلي أحمر",
  "block.minecraft.banner.stripe_bottom.white": "شريط سفلي أبيض",
  "block.minecraft.banner.stripe_bottom.yellow": "شريط سفلي أصفر",
  "block.minecraft.banner.stripe_center.black": "شريط مركزي أسود",
  "block.minecraft.banner.stripe_center.blue": "شريط مركزي أزرق",
  "block.minecraft.banner.stripe_center.brown": "شريط مركزي بني",
  "block.minecraft.banner.stripe_center.cyan": "شريط مركزي سماوي",
  "block.minecraft.banner.stripe_center.gray": "شريط مركزي رمادي",
  "block.minecraft.banner.stripe_center.green": "شريط مركزي أخضر",
  "block.minecraft.banner.stripe_center.light_blue": "شريط مركزي أزرق فاتح",
  "block.minecraft.banner.stripe_center.light_gray": "شريط مركزي رمادي فاتح",
  "block.minecraft.banner.stripe_center.lime": "شريط مركزي ليموني",
  "block.minecraft.banner.stripe_center.magenta": "شريط مركزي أرجواني",
  "block.minecraft.banner.stripe_center.orange": "شريط مركزي برتقالي",
  "block.minecraft.banner.stripe_center.pink": "شريط مركزي وردي",
  "block.minecraft.banner.stripe_center.purple": "شريط مركزي بنفسجي",
  "block.minecraft.banner.stripe_center.red": "شريط مركزي أحمر",
  "block.minecraft.banner.stripe_center.white": "شريط مركزي أبيض",
  "block.minecraft.banner.stripe_center.yellow": "شريط مركزي أصفر",
  "block.minecraft.banner.stripe_downleft.black": "شريط أسود منحني يساراً للأسفل",
  "block.minecraft.banner.stripe_downleft.blue": "شريط أزرق منحني يساراً للأسفل",
  "block.minecraft.banner.stripe_downleft.brown": "شريط بني منحني يساراً للأسفل",
  "block.minecraft.banner.stripe_downleft.cyan": "شريط سماوي منحني يساراً للأسفل",
  "block.minecraft.banner.stripe_downleft.gray": "شريط رمادي منحني يساراً للأسفل",
  "block.minecraft.banner.stripe_downleft.green": "شريط أخضر منحني يساراً للأسفل",
  "block.minecraft.banner.stripe_downleft.light_blue": "شريط أزرق فاتح منحني يساراً للأسفل",
  "block.minecraft.banner.stripe_downleft.light_gray": "شريط رمادي فاتح منحني يساراً للأسفل",
  "block.minecraft.banner.stripe_downleft.lime": "شريط ليموني منحني يساراً للأسفل",
  "block.minecraft.banner.stripe_downleft.magenta": "شريط أرجواني منحني يساراً للأسفل",
  "block.minecraft.banner.stripe_downleft.orange": "شريط برتقالي منحني يساراً للأسفل",
  "block.minecraft.banner.stripe_downleft.pink": "شريط وردي منحني يساراً للأسفل",
  "block.minecraft.banner.stripe_downleft.purple": "شريط بنفسجي منحني يسارا للأسفل",
  "block.minecraft.banner.stripe_downleft.red": "شريط أحمر منحني يساراً للأسفل",
  "block.minecraft.banner.stripe_downleft.white": "شريط أبيض منحني يساراً للأسفل",
  "block.minecraft.banner.stripe_downleft.yellow": "شريط أصفر منحني يساراً للأسفل",
  "block.minecraft.banner.stripe_downright.black": "شريط أسود منحني يميناً للأسفل",
  "block.minecraft.banner.stripe_downright.blue": "شريط أزرق منحني يميناً للأسفل",
  "block.minecraft.banner.stripe_downright.brown": "شريط بني منحني يميناً للأسفل",
  "block.minecraft.banner.stripe_downright.cyan": "شريط سماوي منحني يميناً للأسفل",
  "block.minecraft.banner.stripe_downright.gray": "شريط رمادي منحني يميناً للأسفل",
  "block.minecraft.banner.stripe_downright.green": "شريط أخضر منحني يميناً للأسفل",
  "block.minecraft.banner.stripe_downright.light_blue": "شريط أزرق فاتح منحني يميناً للأسفل",
  "block.minecraft.banner.stripe_downright.light_gray": "شريط رمادي فاتح منحني يميناً للأسفل",
  "block.minecraft.banner.stripe_downright.lime": "شريط ليموني منحني يميناً للأسفل",
  "block.minecraft.banner.stripe_downright.magenta": "شريط أرجواني منحني يميناً للأسفل",
  "block.minecraft.banner.stripe_downright.orange": "شريط برتقالي منحني يميناً للأسفل",
  "block.minecraft.banner.stripe_downright.pink": "شريط وردي منحني يميناً للأسفل",
  "block.minecraft.banner.stripe_downright.purple": "شريط بنفسجي منحني يميناً للأسفل",
  "block.minecraft.banner.stripe_downright.red": "شريط أحمر منحني يميناً للأسفل",
  "block.minecraft.banner.stripe_downright.white": "شريط أبيض منحني يميناً للأسفل",
  "block.minecraft.banner.stripe_downright.yellow": "شريط أصفر منحني يميناً للأسفل",
  "block.minecraft.banner.stripe_left.black": "شريط يساري أسود",
  "block.minecraft.banner.stripe_left.blue": "شريط يساري أزرق",
  "block.minecraft.banner.stripe_left.brown": "شريط يساري بني",
  "block.minecraft.banner.stripe_left.cyan": "شريط يساري سماوي",
  "block.minecraft.banner.stripe_left.gray": "شريط يساري رمادي",
  "block.minecraft.banner.stripe_left.green": "شريط يساري أخضر",
  "block.minecraft.banner.stripe_left.light_blue": "شريط يساري أزرق فاتح",
  "block.minecraft.banner.stripe_left.light_gray": "شريط يساري رمادي فاتح",
  "block.minecraft.banner.stripe_left.lime": "شريط يساري ليموني",
  "block.minecraft.banner.stripe_left.magenta": "شريط يساري أرجواني",
  "block.minecraft.banner.stripe_left.orange": "شريط يساري برتقالي",
  "block.minecraft.banner.stripe_left.pink": "شريط يساري وردي",
  "block.minecraft.banner.stripe_left.purple": "شريط يساري بنفسجي",
  "block.minecraft.banner.stripe_left.red": "شريط يساري أحمر",
  "block.minecraft.banner.stripe_left.white": "شريط يساري أبيض",
  "block.minecraft.banner.stripe_left.yellow": "شريط يساري أصفر",
  "block.minecraft.banner.stripe_middle.black": "شريط وسطي أسود",
  "block.minecraft.banner.stripe_middle.blue": "شريط وسطي أزرق",
  "block.minecraft.banner.stripe_middle.brown": "شريط وسطي بني",
  "block.minecraft.banner.stripe_middle.cyan": "شريط وسطي سماوي",
  "block.minecraft.banner.stripe_middle.gray": "شريط وسطي رمادي",
  "block.minecraft.banner.stripe_middle.green": "شريط وسطي أخضر",
  "block.minecraft.banner.stripe_middle.light_blue": "شريط وسطي أزرق فاتح",
  "block.minecraft.banner.stripe_middle.light_gray": "شريط وسطي رمادي فاتح",
  "block.minecraft.banner.stripe_middle.lime": "شريط وسطي ليموني",
  "block.minecraft.banner.stripe_middle.magenta": "شريط وسطي أرجواني",
  "block.minecraft.banner.stripe_middle.orange": "شريط وسطي برتقالي",
  "block.minecraft.banner.stripe_middle.pink": "شريط وسطي وردي",
  "block.minecraft.banner.stripe_middle.purple": "شريط وسطي بنفسجي",
  "block.minecraft.banner.stripe_middle.red": "شريط وسطي أحمر",
  "block.minecraft.banner.stripe_middle.white": "شريط وسطي أبيض",
  "block.minecraft.banner.stripe_middle.yellow": "شريط وسطي أصفر",
  "block.minecraft.banner.stripe_right.black": "شريط يميني أسود",
  "block.minecraft.banner.stripe_right.blue": "شريط يميني أزرق",
  "block.minecraft.banner.stripe_right.brown": "شريط يميني بني",
  "block.minecraft.banner.stripe_right.cyan": "شريط يميني سماوي",
  "block.minecraft.banner.stripe_right.gray": "شريط يميني رمادي",
  "block.minecraft.banner.stripe_right.green": "شريط يميني أخضر",
  "block.minecraft.banner.stripe_right.light_blue": "شريط يميني أزرق فاتح",
  "block.minecraft.banner.stripe_right.light_gray": "شريط يميني رمادي فاتح",
  "block.minecraft.banner.stripe_right.lime": "شريط يميني ليموني",
  "block.minecraft.banner.stripe_right.magenta": "شريط يميني أرجواني",
  "block.minecraft.banner.stripe_right.orange": "شريط يميني برتقالي",
  "block.minecraft.banner.stripe_right.pink": "شريط يميني وردي",
  "block.minecraft.banner.stripe_right.purple": "شريط يميني بنفسجي",
  "block.minecraft.banner.stripe_right.red": "شريط يميني أحمر",
  "block.minecraft.banner.stripe_right.white": "شريط يميني أبيض",
  "block.minecraft.banner.stripe_right.yellow": "شريط يميني أصفر",
  "block.minecraft.banner.stripe_top.black": "شريط علوي أسود",
  "block.minecraft.banner.stripe_top.blue": "شريط علوي أزرق",
  "block.minecraft.banner.stripe_top.brown": "شريط علوي بني",
  "block.minecraft.banner.stripe_top.cyan": "شريط علوي سماوي",
  "block.minecraft.banner.stripe_top.gray": "شريط علوي رمادي",
  "block.minecraft.banner.stripe_top.green": "شريط علوي أخضر",
  "block.minecraft.banner.stripe_top.light_blue": "شريط علوي أزرق فاتح",
  "block.minecraft.banner.stripe_top.light_gray": "شريط علوي رمادي فاتح",
  "block.minecraft.banner.stripe_top.lime": "شريط علوي ليموني",
  "block.minecraft.banner.stripe_top.magenta": "شريط علوي أرجواني",
  "block.minecraft.banner.stripe_top.orange": "شريط علوي برتقالي",
  "block.minecraft.banner.stripe_top.pink": "شريط علوي وردي",
  "block.minecraft.banner.stripe_top.purple": "شريط علوي بنفسجي",
  "block.minecraft.banner.stripe_top.red": "شريط علوي أحمر",
  "block.minecraft.banner.stripe_top.white": "شريط علوي أبيض",
  "block.minecraft.banner.stripe_top.yellow": "شريط علوي أصفر",
  "block.minecraft.banner.triangle_bottom.black": "مثلث أسود",
  "block.minecraft.banner.triangle_bottom.blue": "مثلث أزرق",
  "block.minecraft.banner.triangle_bottom.brown": "مثلث بني",
  "block.minecraft.banner.triangle_bottom.cyan": "مثلث سماوي",
  "block.minecraft.banner.triangle_bottom.gray": "مثلث رمادي",
  "block.minecraft.banner.triangle_bottom.green": "مثلث أخضر",
  "block.minecraft.banner.triangle_bottom.light_blue": "مثلث أزرق فاتح",
  "block.minecraft.banner.triangle_bottom.light_gray": "مثلث رمادي فاتح",
  "block.minecraft.banner.triangle_bottom.lime": "مثلث ليموني",
  "block.minecraft.banner.triangle_bottom.magenta": "مثلث أرجواني",
  "block.minecraft.banner.triangle_bottom.orange": "مثلث برتقالي",
  "block.minecraft.banner.triangle_bottom.pink": "مثلث وردي",
  "block.minecraft.banner.triangle_bottom.purple": "مثلث بنفسجي",
  "block.minecraft.banner.triangle_bottom.red": "مثلث أحمر",
  "block.minecraft.banner.triangle_bottom.white": "مثلث أبيض",
  "block.minecraft.banner.triangle_bottom.yellow": "مثلث أصفر",
  "block.minecraft.banner.triangle_top.black": "مثلث مقلوب أسود",
  "block.minecraft.banner.triangle_top.blue": "مثلث مقلوب أزرق",
  "block.minecraft.banner.triangle_top.brown": "مثلث مقلوب بني",
  "block.minecraft.banner.triangle_top.cyan": "مثلث مقلوب سماوي",
  "block.minecraft.banner.triangle_top.gray": "مثلث مقلوب رمادي",
  "block.minecraft.banner.triangle_top.green": "مثلث مقلوب أخضر",
  "block.minecraft.banner.triangle_top.light_blue": "مثلث مقلوب أزرق فاتح",
  "block.minecraft.banner.triangle_top.light_gray": "مثلث مقلوب رمادي فاتح",
  "block.minecraft.banner.triangle_top.lime": "مثلث مقلوب ليموني",
  "block.minecraft.banner.triangle_top.magenta": "مثلث مقلوب أرجواني",
  "block.minecraft.banner.triangle_top.orange": "مثلث مقلوب برتقالي",
  "block.minecraft.banner.triangle_top.pink": "مثلث مقلوب وردي",
  "block.minecraft.banner.triangle_top.purple": "مثلث مقلوب بنفسجي",
  "block.minecraft.banner.triangle_top.red": "مثلث مقلوب أحمر",
  "block.minecraft.banner.triangle_top.white": "مثلث مقلوب أبيض",
  "block.minecraft.banner.triangle_top.yellow": "مثلث مقلوب أصفر",
  "block.minecraft.banner.triangles_bottom.black": "مثلثات سفلية سوداء",
  "block.minecraft.banner.triangles_bottom.blue": "مثلثات سفلية زرقاء",
  "block.minecraft.banner.triangles_bottom.brown": "مثلثات سفلية بنية",
  "block.minecraft.banner.triangles_bottom.cyan": "مثلثات سفلية سماوية",
  "block.minecraft.banner.triangles_bottom.gray": "مثلثات سفلية رمادية",
  "block.minecraft.banner.triangles_bottom.green": "مثلثات سفلية جضراء",
  "block.minecraft.banner.triangles_bottom.light_blue": "مثلثات سفلية زرقاء فاتحة",
  "block.minecraft.banner.triangles_bottom.light_gray": "مثلثات سفلية رمادية فاتحة",
  "block.minecraft.banner.triangles_bottom.lime": "مثلثات سفلية ليمونية",
  "block.minecraft.banner.triangles_bottom.magenta": "مثلثات سفلية أرجوانية",
  "block.minecraft.banner.triangles_bottom.orange": "مثلثات سفلية برتقالية",
  "block.minecraft.banner.triangles_bottom.pink": "مثلثات سفلية وردية",
  "block.minecraft.banner.triangles_bottom.purple": "مثلثات سفلية بنفسجية",
  "block.minecraft.banner.triangles_bottom.red": "مثلثات سفلية حمراء",
  "block.minecraft.banner.triangles_bottom.white": "مثلثات سفلية بيضاء",
  "block.minecraft.banner.triangles_bottom.yellow": "مثلثات سفلية صفراء",
  "block.minecraft.banner.triangles_top.black": "مثلثات علوية سوداء",
  "block.minecraft.banner.triangles_top.blue": "مثلثات علوية زرقاء",
  "block.minecraft.banner.triangles_top.brown": "مثلثات علوية بنية",
  "block.minecraft.banner.triangles_top.cyan": "مثلثات علوية سماوية",
  "block.minecraft.banner.triangles_top.gray": "مثلثات علوية رمادية",
  "block.minecraft.banner.triangles_top.green": "مثلثات علوية خضراء",
  "block.minecraft.banner.triangles_top.light_blue": "مثلثات علوية زرقاء فاتحة",
  "block.minecraft.banner.triangles_top.light_gray": "مثلثات علوية رمادية فاتحة",
  "block.minecraft.banner.triangles_top.lime": "مثلثات علوية ليمونية",
  "block.minecraft.banner.triangles_top.magenta": "مثلثات علوية أرجوانية",
  "block.minecraft.banner.triangles_top.orange": "مثلثات علوية برتقالية",
  "block.minecraft.banner.triangles_top.pink": "مثلثات علوية وردية",
  "block.minecraft.banner.triangles_top.purple": "مثلثات علوية بنفسجية",
  "block.minecraft.banner.triangles_top.red": "مثلثات علوية حمراء",
  "block.minecraft.banner.triangles_top.white": "مثلثات علوية بيضاء",
  "block.minecraft.banner.triangles_top.yellow": "مثلثات علوية صفراء",
  "block.minecraft.barrel": "برميل",
  "block.minecraft.barrier": "حاجز",
  "block.minecraft.basalt": "بازالت",
  "block.minecraft.beacon": "منارة",
  "block.minecraft.beacon.primary": "الطاقة الأولية",
  "block.minecraft.beacon.secondary": "الطاقة الثانوية",
  "block.minecraft.bed.no_sleep": "يمكنك النوم فقط في الليل أو أثناء العواصف الرعدية",
  "block.minecraft.bed.not_safe": "لا يمكنك النوم الآن؛ هناك وحوش بالقرب منك",
  "block.minecraft.bed.obstructed": "هذا السرير مسدود",
  "block.minecraft.bed.occupied": "هذا السرير مشغول",
  "block.minecraft.bed.too_far_away": "لا يمكنك النوم الآن؛ السرير بعيد جداً",
  "block.minecraft.bedrock": "صخر القاع",
  "block.minecraft.bee_nest": "عش نحل",
  "block.minecraft.beehive": "خلية نحل",
  "block.minecraft.beetroots": "شمندر",
  "block.minecraft.bell": "جرس",
  "block.minecraft.big_dripleaf": "ورقة تقطير كبيرة",
  "block.minecraft.big_dripleaf_stem": "ساق ورقة تقطير كبيرة",
  "block.minecraft.birch_button": "زر البتولا",
  "block.minecraft.birch_door": "باب البتولا",
  "block.minecraft.birch_fence": "سياج البتولا",
  "block.minecraft.birch_fence_gate": "بوابة سياج البتولا",
  "block.minecraft.birch_hanging_sign": "لافتة البتولا المعلقة",
  "block.minecraft.birch_leaves": "أوراق البتولا",
  "block.minecraft.birch_log": "جذع البتولا",
  "block.minecraft.birch_planks": "ألواح خشب البتولا",
  "block.minecraft.birch_pressure_plate": "صفيحة ضغط خشب البتولا",
  "block.minecraft.birch_sapling": "شتلة البتولا",
  "block.minecraft.birch_shelf": "رف البتولا",
  "block.minecraft.birch_sign": "لافتة من البتولا",
  "block.minecraft.birch_slab": "بلاطة البتولا",
  "block.minecraft.birch_stairs": "درج البتولا",
  "block.minecraft.birch_trapdoor": "باب أرضي من خشب البتولا",
  "block.minecraft.birch_wall_hanging_sign": "لافتة البتولا المعلقة على الحائط",
  "block.minecraft.birch_wall_sign": "لافتة جدارية من البتولا",
  "block.minecraft.birch_wood": "خشب البتولا",
  "block.minecraft.black_banner": "راية سوداء",
  "block.minecraft.black_bed": "سرير أسود",
  "block.minecraft.black_candle": "شمعة سوداء",
  "block.minecraft.black_candle_cake": "كعكة مع شمعة سوداء",
  "block.minecraft.black_carpet": "سجاد أسود",
  "block.minecraft.black_concrete": "أسمنت أسود",
  "block.minecraft.black_concrete_powder": "مسحوق أسمنت أسود",
  "block.minecraft.black_glazed_terracotta": "طين المزجج الأسود",
  "block.minecraft.black_shulker_box": "صندوق شلكر أسود",
  "block.minecraft.black_stained_glass": "زجاج اسود",
  "block.minecraft.black_stained_glass_pane": "لوح زجاجي أسود",
  "block.minecraft.black_terracotta": "طين النضيج الأسود",
  "block.minecraft.black_wool": "صوف أسود",
  "block.minecraft.blackstone": "حجر أسود",
  "block.minecraft.blackstone_slab": "بلاطة حجر أسود",
  "block.minecraft.blackstone_stairs": "درج حجر أسود",
  "block.minecraft.blackstone_wall": "جدار حجر أسود",
  "block.minecraft.blast_furnace": "فرن صهر المعادن",
  "block.minecraft.blue_banner": "راية زرقاء",
  "block.minecraft.blue_bed": "سرير أزرق",
  "block.minecraft.blue_candle": "شمعة زرقاء",
  "block.minecraft.blue_candle_cake": "كعكة مع شمعة زرقاء",
  "block.minecraft.blue_carpet": "سجاد أزرق",
  "block.minecraft.blue_concrete": "أسمنت أزرق",
  "block.minecraft.blue_concrete_powder": "مسحوق أسمنت أزرق",
  "block.minecraft.blue_glazed_terracotta": "طين المزجج الأزرق",
  "block.minecraft.blue_ice": "جليد أزرق",
  "block.minecraft.blue_orchid": "أوركيد أزرق",
  "block.minecraft.blue_shulker_box": "صندوق شلكر أزرق",
  "block.minecraft.blue_stained_glass": "زجاج ازرق",
  "block.minecraft.blue_stained_glass_pane": "لوح زجاجي أزرق",
  "block.minecraft.blue_terracotta": "طين النضيج الأزرق",
  "block.minecraft.blue_wool": "صوف أزرق",
  "block.minecraft.bone_block": "كتلة عظام",
  "block.minecraft.bookshelf": "رف كتب",
  "block.minecraft.brain_coral": "مرجان عقلي",
  "block.minecraft.brain_coral_block": "كتلة مرجان عقلي",
  "block.minecraft.brain_coral_fan": "شعاب مرجان عقلي",
  "block.minecraft.brain_coral_wall_fan": "شعاب مرجان عقلي جداري",
  "block.minecraft.brewing_stand": "منضدة التخمير",
  "block.minecraft.brick_slab": "بلاطة طوب",
  "block.minecraft.brick_stairs": "درج من الطوب",
  "block.minecraft.brick_wall": "جدار طوبي",
  "block.minecraft.bricks": "طوب",
  "block.minecraft.brown_banner": "راية بنية",
  "block.minecraft.brown_bed": "سرير بني",
  "block.minecraft.brown_candle": "شمعة بنية",
  "block.minecraft.brown_candle_cake": "كعكة مع شمعة بنية",
  "block.minecraft.brown_carpet": "سجاد بني",
  "block.minecraft.brown_concrete": "أسمنت بني",
  "block.minecraft.brown_concrete_powder": "مسحوق أسمنت بني",
  "block.minecraft.brown_glazed_terracotta": "طين المزجج البني",
  "block.minecraft.brown_mushroom": "فطر بني",
  "block.minecraft.brown_mushroom_block": "مكعب الفطر البني",
  "block.minecraft.brown_shulker_box": "صندوق شلكر بني",
  "block.minecraft.brown_stained_glass": "زجاج بني",
  "block.minecraft.brown_stained_glass_pane": "لوح زجاجي بني",
  "block.minecraft.brown_terracotta": "طين النضيج البني",
  "block.minecraft.brown_wool": "صوف بني",
  "block.minecraft.bubble_column": "عمود فقاعات",
  "block.minecraft.bubble_coral": "مرجان فقاعي",
  "block.minecraft.bubble_coral_block": "كتلة مرجان فقاعي",
  "block.minecraft.bubble_coral_fan": "شعاب مرجان فقاعي",
  "block.minecraft.bubble_coral_wall_fan": "شعاب مرجان فقاعي جداري",
  "block.minecraft.budding_amethyst": "أماثيست متبرعم",
  "block.minecraft.bush": "شجيرة",
  "block.minecraft.cactus": "صبار",
  "block.minecraft.cactus_flower": "زهرة الصبار",
  "block.minecraft.cake": "كعكة",
  "block.minecraft.calcite": "كالسيت",
  "block.minecraft.calibrated_sculk_sensor": "معايرة حساس السكلك",
  "block.minecraft.campfire": "موقد نار",
  "block.minecraft.candle": "شمعة",
  "block.minecraft.candle_cake": "كعكة مع شمعة",
  "block.minecraft.carrots": "جزر",
  "block.minecraft.cartography_table": "طاولة رسم الخرائط",
  "block.minecraft.carved_pumpkin": "يقطين منحوت",
  "block.minecraft.cauldron": "قدر",
  "block.minecraft.cave_air": "هواء الكهف",
  "block.minecraft.cave_vines": "كرمة الكهف",
  "block.minecraft.cave_vines_plant": "نبتة كرمة الكهف",
  "block.minecraft.chain": "سلسلة حديدية",
  "block.minecraft.chain_command_block": "كتلة الأوامر المتسلسلة",
  "block.minecraft.cherry_button": "زر الكرز",
  "block.minecraft.cherry_door": "باب الكرز",
  "block.minecraft.cherry_fence": "سياج الكرز",
  "block.minecraft.cherry_fence_gate": "بوابة سياج الكرز",
  "block.minecraft.cherry_hanging_sign": "لافتة الكرز معلقة",
  "block.minecraft.cherry_leaves": "أوراق الكرز",
  "block.minecraft.cherry_log": "جذع الكرز",
  "block.minecraft.cherry_planks": "ألواح خشب الكرز",
  "block.minecraft.cherry_pressure_plate": "صفيحة ضغط خشب الكرز",
  "block.minecraft.cherry_sapling": "شتلة الكرز",
  "block.minecraft.cherry_shelf": "رف الكرز",
  "block.minecraft.cherry_sign": "لافتة من الكرز",
  "block.minecraft.cherry_slab": "بلاطة الكرز",
  "block.minecraft.cherry_stairs": "درج الكرز",
  "block.minecraft.cherry_trapdoor": "باب أرضي من خشب الكرز",
  "block.minecraft.cherry_wall_hanging_sign": "لافتة جدارية من الكرز معلقة",
  "block.minecraft.cherry_wall_sign": "لافتة جدارية من الكرز",
  "block.minecraft.cherry_wood": "خشب الكرز",
  "block.minecraft.chest": "صندوق",
  "block.minecraft.chipped_anvil": "سندان متكسر",
  "block.minecraft.chiseled_bookshelf": "رف كتب محفور",
  "block.minecraft.chiseled_copper": "نحاس منحوت",
  "block.minecraft.chiseled_deepslate": "حجر عميق منقوش",
  "block.minecraft.chiseled_nether_bricks": "طوب النذر المنقوش",
  "block.minecraft.chiseled_polished_blackstone": "حجر أسود مصقول منقوش",
  "block.minecraft.chiseled_quartz_block": "كتلة كوارتز منحوت",
  "block.minecraft.chiseled_red_sandstone": "حجر رملي أحمر منقوش",
  "block.minecraft.chiseled_resin_bricks": "طوب الراتنج المنحوت",
  "block.minecraft.chiseled_sandstone": "حجر رملي منقوش",
  "block.minecraft.chiseled_stone_bricks": "طوب حجري منقوش",
  "block.minecraft.chiseled_tuff": "حجر بركاني منحوت",
  "block.minecraft.chiseled_tuff_bricks": "حجارة بركانية منحوتة",
  "block.minecraft.chorus_flower": "زهرة الكورس",
  "block.minecraft.chorus_plant": "نبتة الكورس",
  "block.minecraft.clay": "صلصال",
  "block.minecraft.closed_eyeblossom": "زهرة عين مغلقة",
  "block.minecraft.coal_block": "كتلة من الفحم",
  "block.minecraft.coal_ore": "خام الفحم",
  "block.minecraft.coarse_dirt": "تراب خشن",
  "block.minecraft.cobbled_deepslate": "حجر عميق مرصوف بالحصى",
  "block.minecraft.cobbled_deepslate_slab": "بلاطة حجر عميق مرصوف بالحصى",
  "block.minecraft.cobbled_deepslate_stairs": "درج حجر عميق مرصوف بالحصى",
  "block.minecraft.cobbled_deepslate_wall": "جدار حجر عميق مرصوف بالحصى",
  "block.minecraft.cobblestone": "حصاة الرصف",
  "block.minecraft.cobblestone_slab": "بلاطة حصاة الرصف",
  "block.minecraft.cobblestone_stairs": "درج حصاة الرصف",
  "block.minecraft.cobblestone_wall": "جدار حصاة الرصف",
  "block.minecraft.cobweb": "شبكة العنكبوت",
  "block.minecraft.cocoa": "كاكاو",
  "block.minecraft.command_block": "كتلة الأوامر",
  "block.minecraft.comparator": "مقارن الريدستون",
  "block.minecraft.composter": "مسمِّد",
  "block.minecraft.conduit": "نواة المحيط",
  "block.minecraft.copper_bars": "قضبان نحاسية",
  "block.minecraft.copper_block": "كتلة من النحاس",
  "block.minecraft.copper_bulb": "مصباح نحاسي",
  "block.minecraft.copper_chain": "سلسلة نحاسية",
  "block.minecraft.copper_chest": "صندوق نحاسي",
  "block.minecraft.copper_door": "باب نحاسي",
  "block.minecraft.copper_golem_statue": "تمثال رجل نحاسي",
  "block.minecraft.copper_grate": "شبك نحاسي",
  "block.minecraft.copper_lantern": "فانوس نحاسي",
  "block.minecraft.copper_ore": "خام النحاس",
  "block.minecraft.copper_torch": "شعلة نحاسية",
  "block.minecraft.copper_trapdoor": "باب أرضي نحاسي",
  "block.minecraft.copper_wall_torch": "شعلة جدارية نحاسية",
  "block.minecraft.cornflower": "وردة الذرة",
  "block.minecraft.cracked_deepslate_bricks": "طوب حجر عميق متشقق",
  "block.minecraft.cracked_deepslate_tiles": "قرميد حجر عميق متشقق",
  "block.minecraft.cracked_nether_bricks": "طوب النذر المتشقق",
  "block.minecraft.cracked_polished_blackstone_bricks": "طوب حجر أسود مصقول متشقق",
  "block.minecraft.cracked_stone_bricks": "طوب حجري متشقق",
  "block.minecraft.crafter": "صانع",
  "block.minecraft.crafting_table": "طاولة النجارة",
  "block.minecraft.creaking_heart": "قلب الصرير",
  "block.minecraft.creeper_head": "رأس كريبر",
  "block.minecraft.creeper_wall_head": "رأس كريبر حائطي",
  "block.minecraft.crimson_button": "زر قرمزي",
  "block.minecraft.crimson_door": "باب قرمزي",
  "block.minecraft.crimson_fence": "سياج قرمزي",
  "block.minecraft.crimson_fence_gate": "بوابة سياج قرمزية",
  "block.minecraft.crimson_fungus": "فطر قرمزي",
  "block.minecraft.crimson_hanging_sign": "لافتة قرمزية معلقة",
  "block.minecraft.crimson_hyphae": "لحاء قرمزي",
  "block.minecraft.crimson_nylium": "نيليوم قرمزي",
  "block.minecraft.crimson_planks": "ألواح خشب قرمزية",
  "block.minecraft.crimson_pressure_plate": "صفيحة ضغط قرمزية",
  "block.minecraft.crimson_roots": "جذور قرمزية",
  "block.minecraft.crimson_shelf": "رف القرمزي",
  "block.minecraft.crimson_sign": "لافتة قرمزية",
  "block.minecraft.crimson_slab": "بلاطة قرمزية",
  "block.minecraft.crimson_stairs": "درج قرمزي",
  "block.minecraft.crimson_stem": "جذع قرمزي",
  "block.minecraft.crimson_trapdoor": "باب أرضي قرمزي",
  "block.minecraft.crimson_wall_hanging_sign": "لافتة جدارية قرمزية معلقة",
  "block.minecraft.crimson_wall_sign": "لافتة جدارية قرمزية",
  "block.minecraft.crying_obsidian": "السبج الباكي",
  "block.minecraft.cut_copper": "نحاس مقطع",
  "block.minecraft.cut_copper_slab": "بلاطة نحاس مقطع",
  "block.minecraft.cut_copper_stairs": "درج نحاس مقطع",
  "block.minecraft.cut_red_sandstone": "حجر رملي أحمر مقطع",
  "block.minecraft.cut_red_sandstone_slab": "بلاطة حجر رملي أحمر مقطعة",
  "block.minecraft.cut_sandstone": "الحجر رملي مقطع",
  "block.minecraft.cut_sandstone_slab": "بلاطة حجر رملي مقطعة",
  "block.minecraft.cyan_banner": "راية سماوية",
  "block.minecraft.cyan_bed": "سرير سماوي",
  "block.minecraft.cyan_candle": "شمعة سماوية",
  "block.minecraft.cyan_candle_cake": "كعكة مع شمعة زرقاء سماوية",
  "block.minecraft.cyan_carpet": "سجاد سماوي",
  "block.minecraft.cyan_concrete": "أسمنت سماوي",
  "block.minecraft.cyan_concrete_powder": "مسحوق أسمنت سماوي",
  "block.minecraft.cyan_glazed_terracotta": "طين المزجج السماوي",
  "block.minecraft.cyan_shulker_box": "صندوق شلكر سماوي",
  "block.minecraft.cyan_stained_glass": "زجاج سماوي",
  "block.minecraft.cyan_stained_glass_pane": "لوح زجاجي سماوي",
  "block.minecraft.cyan_terracotta": "طين النضيج السماوي",
  "block.minecraft.cyan_wool": "صوف سماوي",
  "block.minecraft.damaged_anvil": "سندان المتضرر",
  "block.minecraft.dandelion": "الهندباء",
  "block.minecraft.dark_oak_button": "زر البلوط الداكن",
  "block.minecraft.dark_oak_door": "باب البلوط الداكن",
  "block.minecraft.dark_oak_fence": "سياج البلوط الداكن",
  "block.minecraft.dark_oak_fence_gate": "بوابة سياج البلوط الداكن",
  "block.minecraft.dark_oak_hanging_sign": "لافتة البلوط الداكن معلقة",
  "block.minecraft.dark_oak_leaves": "أوراق البلوط الداكن",
  "block.minecraft.dark_oak_log": "جذع البلوط الداكن",
  "block.minecraft.dark_oak_planks": "ألواح خشب البلوط الداكن",
  "block.minecraft.dark_oak_pressure_plate": "صفيحة ضغط خشب البلوط الداكن",
  "block.minecraft.dark_oak_sapling": "شتلة البلوط الداكن",
  "block.minecraft.dark_oak_shelf": "رف البلوط الداكن",
  "block.minecraft.dark_oak_sign": "لافتة من البلوط الداكن",
  "block.minecraft.dark_oak_slab": "بلاطة البلوط الداكن",
  "block.minecraft.dark_oak_stairs": "درج البلوط الداكن",
  "block.minecraft.dark_oak_trapdoor": "باب أرضي من خشب البلوط الداكن",
  "block.minecraft.dark_oak_wall_hanging_sign": "لافتة جدارية من البلوط الداكن معلقة",
  "block.minecraft.dark_oak_wall_sign": "لافتة جدارية من البلوط الداكن",
  "block.minecraft.dark_oak_wood": "خشب البلوط الداكن",
  "block.minecraft.dark_prismarine": "بريسمارين داكن",
  "block.minecraft.dark_prismarine_slab": "بلاطة البريسمارين الداكن",
  "block.minecraft.dark_prismarine_stairs": "درج البريسمارين الداكن",
  "block.minecraft.daylight_detector": "حساس ضوء الشمس",
  "block.minecraft.dead_brain_coral": "مرجان عقلي ميت",
  "block.minecraft.dead_brain_coral_block": "كتلة مرجان عقلي ميت",
  "block.minecraft.dead_brain_coral_fan": "شعاب مرجان عقلي ميت",
  "block.minecraft.dead_brain_coral_wall_fan": "شعاب مرجان عقلي جداري ميت",
  "block.minecraft.dead_bubble_coral": "مرجان فقاعي ميت",
  "block.minecraft.dead_bubble_coral_block": "كتلة مرجان فقاعي ميت",
  "block.minecraft.dead_bubble_coral_fan": "شعاب مرجان فقاعي ميت",
  "block.minecraft.dead_bubble_coral_wall_fan": "شعاب مرجان فقاعي جداري ميت",
  "block.minecraft.dead_bush": "شجيرة ميتة",
  "block.minecraft.dead_fire_coral": "مرجان ناري ميت",
  "block.minecraft.dead_fire_coral_block": "كتلة مرجان ناري ميت",
  "block.minecraft.dead_fire_coral_fan": "شعاب مرجان ناري ميت",
  "block.minecraft.dead_fire_coral_wall_fan": "شعاب مرجان ناري جداري ميت",
  "block.minecraft.dead_horn_coral": "مرجان بوقي ميت",
  "block.minecraft.dead_horn_coral_block": "كتلة مرجان بوقي ميت",
  "block.minecraft.dead_horn_coral_fan": "شعاب مرجان قرني ميت",
  "block.minecraft.dead_horn_coral_wall_fan": "شعاب مرجان بوقي جداري ميت",
  "block.minecraft.dead_tube_coral": "مرجان أنبوبي ميت",
  "block.minecraft.dead_tube_coral_block": "كتلة مرجان أنبوبي ميت",
  "block.minecraft.dead_tube_coral_fan": "شعاب مرجان أنبوبي ميت",
  "block.minecraft.dead_tube_coral_wall_fan": "شعاب مرجان أُنبوبي جداري ميت",
  "block.minecraft.decorated_pot": "جرة مزينة",
  "block.minecraft.deepslate": "حجر عميق",
  "block.minecraft.deepslate_brick_slab": "بلاطة طوب حجر عميق",
  "block.minecraft.deepslate_brick_stairs": "درج طوب حجر عميق",
  "block.minecraft.deepslate_brick_wall": "جدار طوب حجر عميق",
  "block.minecraft.deepslate_bricks": "طوب حجر عميق",
  "block.minecraft.deepslate_coal_ore": "خام الفحم العميق",
  "block.minecraft.deepslate_copper_ore": "خام النحاس العميق",
  "block.minecraft.deepslate_diamond_ore": "خام الألماس العميق",
  "block.minecraft.deepslate_emerald_ore": "خام الزمرد العميق",
  "block.minecraft.deepslate_gold_ore": "خام الذهب العميق",
  "block.minecraft.deepslate_iron_ore": "خام الحديد العميق",
  "block.minecraft.deepslate_lapis_ore": "خام اللازورد العميق",
  "block.minecraft.deepslate_redstone_ore": "خام الريدستون العميق",
  "block.minecraft.deepslate_tile_slab": "بلاطة طوب حجر عميق",
  "block.minecraft.deepslate_tile_stairs": "درج قرميد حجر عميق",
  "block.minecraft.deepslate_tile_wall": "جدار قرميد حجر عميق",
  "block.minecraft.deepslate_tiles": "طوب حجر عميق",
  "block.minecraft.detector_rail": "سكة حديدية مستشعرة",
  "block.minecraft.diamond_block": "كتلة من الألماس",
  "block.minecraft.diamond_ore": "خام الألماس",
  "block.minecraft.diorite": "ديوريت",
  "block.minecraft.diorite_slab": "بلاطة ديوريت",
  "block.minecraft.diorite_stairs": "درج ديوريت",
  "block.minecraft.diorite_wall": "جدار ديوريت",
  "block.minecraft.dirt": "تراب",
  "block.minecraft.dirt_path": "طريق ترابي",
  "block.minecraft.dispenser": "قاذف",
  "block.minecraft.dragon_egg": "بيضة تنين",
  "block.minecraft.dragon_head": "رأس التنين",
  "block.minecraft.dragon_wall_head": "رأس تنين حائطي",
  "block.minecraft.dried_ghast": "شبحٌ جافّ",
  "block.minecraft.dried_kelp_block": "كتلة عشب البحر المجفف",
  "block.minecraft.dripstone_block": "كتلة حجر التنقيط",
  "block.minecraft.dropper": "قطارة",
  "block.minecraft.emerald_block": "كتلة من الزمرد",
  "block.minecraft.emerald_ore": "خام الزمرد",
  "block.minecraft.enchanting_table": "طاولة السحر",
  "block.minecraft.end_gateway": "مدخل الاند",
  "block.minecraft.end_portal": "بوابة الاند",
  "block.minecraft.end_portal_frame": "إطار بوابة الاند",
  "block.minecraft.end_rod": "عود الاند",
  "block.minecraft.end_stone": "حجر الاند",
  "block.minecraft.end_stone_brick_slab": "بلاطة طوب حجر الاند",
  "block.minecraft.end_stone_brick_stairs": "درج طوب حجر الاند",
  "block.minecraft.end_stone_brick_wall": "جدار طوب حجر الاند",
  "block.minecraft.end_stone_bricks": "طوب حجر الاند",
  "block.minecraft.ender_chest": "صندوق الاندر",
  "block.minecraft.exposed_chiseled_copper": "نحاس منحوت مكشوف",
  "block.minecraft.exposed_copper": "نحاس مكشوف",
  "block.minecraft.exposed_copper_bars": "قضبان نحاسية مكشوفة",
  "block.minecraft.exposed_copper_bulb": "مصباح نحاسي مكشوف",
  "block.minecraft.exposed_copper_chain": "سلسلة نحاسية مكشوفة",
  "block.minecraft.exposed_copper_chest": "صندوق نحاسي مكشوف",
  "block.minecraft.exposed_copper_door": "باب نحاسي مكشوف",
  "block.minecraft.exposed_copper_golem_statue": "تمثال رجل نحاسي مكشوف",
  "block.minecraft.exposed_copper_grate": "شبك نحاسي مكشوف",
  "block.minecraft.exposed_copper_lantern": "فانوس نحاسي مكشوف",
  "block.minecraft.exposed_copper_trapdoor": "باب أرضي نحاسي مكشوف",
  "block.minecraft.exposed_cut_copper": "نحاس مكشوف مقطع",
  "block.minecraft.exposed_cut_copper_slab": "بلاطة نحاس مقطع مكشوف",
  "block.minecraft.exposed_cut_copper_stairs": "درج نحاس مقطع مكشوف",
  "block.minecraft.exposed_lightning_rod": "عصا البرق المكشوفة",
  "block.minecraft.farmland": "أرض زراعية",
  "block.minecraft.fern": "سرخس",
  "block.minecraft.fire": "نار",
  "block.minecraft.fire_coral": "مرجان ناري",
  "block.minecraft.fire_coral_block": "كتلة مرجان ناري",
  "block.minecraft.fire_coral_fan": "شعاب مرجان ناري",
  "block.minecraft.fire_coral_wall_fan": "شعاب مرجان ناري جداري",
  "block.minecraft.firefly_bush": "شجيرة اليراعات",
  "block.minecraft.fletching_table": "طاولة صناعة الأسهم",
  "block.minecraft.flower_pot": "وعاء الزهور",
  "block.minecraft.flowering_azalea": "أزاليا مزهرة",
  "block.minecraft.flowering_azalea_leaves": "أوراق الأزاليا المزهرة",
  "block.minecraft.frogspawn": "بيض الضفدع",
  "block.minecraft.frosted_ice": "جليد متجمد",
  "block.minecraft.furnace": "فرن",
  "block.minecraft.gilded_blackstone": "حجر أسود مُذَهَّب",
  "block.minecraft.glass": "زجاج",
  "block.minecraft.glass_pane": "لوح زجاجي",
  "block.minecraft.glow_lichen": "حزاز متوهج",
  "block.minecraft.glowstone": "حجر مضيء",
  "block.minecraft.gold_block": "كتلة من الذهب",
  "block.minecraft.gold_ore": "خام الذهب",
  "block.minecraft.golden_dandelion": "الهندباء الذهبية",
  "block.minecraft.granite": "جرانيت",
  "block.minecraft.granite_slab": "بلاطة جرانيت",
  "block.minecraft.granite_stairs": "درج جرانيت",
  "block.minecraft.granite_wall": "جدار جرانيت",
  "block.minecraft.grass": "عشب",
  "block.minecraft.grass_block": "كتلة عشب",
  "block.minecraft.gravel": "حصى",
  "block.minecraft.gray_banner": "راية رمادية",
  "block.minecraft.gray_bed": "سرير رمادي",
  "block.minecraft.gray_candle": "شمعة رمادية",
  "block.minecraft.gray_candle_cake": "كعكة مع شمعة رمادية",
  "block.minecraft.gray_carpet": "سجاد رمادي",
  "block.minecraft.gray_concrete": "الاسمنت رمادي",
  "block.minecraft.gray_concrete_powder": "مسحوق أسمنت رمادي",
  "block.minecraft.gray_glazed_terracotta": "طين المزجج الرمادي",
  "block.minecraft.gray_shulker_box": "صندوق شلكر رمادي",
  "block.minecraft.gray_stained_glass": "زجاج رمادي",
  "block.minecraft.gray_stained_glass_pane": "لوح زجاجي رمادي",
  "block.minecraft.gray_terracotta": "طين النضيج الرمادي",
  "block.minecraft.gray_wool": "صوف رمادي",
  "block.minecraft.green_banner": "راية خضراء",
  "block.minecraft.green_bed": "سرير أخضر",
  "block.minecraft.green_candle": "شمعة خضراء",
  "block.minecraft.green_candle_cake": "كعكة مع شمعة خضراء",
  "block.minecraft.green_carpet": "سجاد أخضر",
  "block.minecraft.green_concrete": "أسمنت أخضر",
  "block.minecraft.green_concrete_powder": "مسحوق أسمنت أخضر",
  "block.minecraft.green_glazed_terracotta": "طين المزجج الأخضر",
  "block.minecraft.green_shulker_box": "صندوق شلكر أخضر",
  "block.minecraft.green_stained_glass": "زجاج اخضر",
  "block.minecraft.green_stained_glass_pane": "لوح زجاجي أخضر",
  "block.minecraft.green_terracotta": "طين النضيج الأخضر",
  "block.minecraft.green_wool": "صوف أخضر",
  "block.minecraft.grindstone": "حجر الشحذ",
  "block.minecraft.hanging_roots": "جذور معلقة",
  "block.minecraft.hay_block": "كومة قش",
  "block.minecraft.heavy_core": "الجوهر الثقيل",
  "block.minecraft.heavy_weighted_pressure_plate": "صفيحة ضغط ثقيلة الوزن",
  "block.minecraft.honey_block": "كتلة عسل",
  "block.minecraft.honeycomb_block": "كتله أقراص العسل",
  "block.minecraft.hopper": "هوبر",
  "block.minecraft.horn_coral": "مرجان بوقي",
  "block.minecraft.horn_coral_block": "كتلة مرجان بوقي",
  "block.minecraft.horn_coral_fan": "شعاب مرجان بوقي",
  "block.minecraft.horn_coral_wall_fan": "شعاب مرجان بوقي جداري",
  "block.minecraft.ice": "جليد",
  "block.minecraft.infested_chiseled_stone_bricks": "طوب حجري منقوش مسكون",
  "block.minecraft.infested_cobblestone": "حصاة الرصف المسكونة",
  "block.minecraft.infested_cracked_stone_bricks": "طوب حجري متشقق مسكون",
  "block.minecraft.infested_deepslate": "حجر عميق مسكون",
  "block.minecraft.infested_mossy_stone_bricks": "طوب حجري طحلبي مسكون",
  "block.minecraft.infested_stone": "حجر مسكون",
  "block.minecraft.infested_stone_bricks": "طوب حجري مسكون",
  "block.minecraft.iron_bars": "قضبان حديدية",
  "block.minecraft.iron_block": "كتلة من الحديد",
  "block.minecraft.iron_chain": "سلسلة حديدية",
  "block.minecraft.iron_door": "باب حديدي",
  "block.minecraft.iron_ore": "خام الحديد",
  "block.minecraft.iron_trapdoor": "باب أرضي حديدي",
  "block.minecraft.jack_o_lantern": "يقطين مضيء",
  "block.minecraft.jigsaw": "كتلة بانورامية",
  "block.minecraft.jukebox": "صندوق الموسيقى",
  "block.minecraft.jungle_button": "زر الأدغال",
  "block.minecraft.jungle_door": "باب الأدغال",
  "block.minecraft.jungle_fence": "سياج الأدغال",
  "block.minecraft.jungle_fence_gate": "بوابة سياج الأدغال",
  "block.minecraft.jungle_hanging_sign": "لافتة خشب الأدغال معلقة",
  "block.minecraft.jungle_leaves": "أوراق الأدغال",
  "block.minecraft.jungle_log": "جذع الأدغال",
  "block.minecraft.jungle_planks": "ألواح خشب الأدغال",
  "block.minecraft.jungle_pressure_plate": "صفيحة ضغط خشب الأدغال",
  "block.minecraft.jungle_sapling": "شتلة الأدغال",
  "block.minecraft.jungle_shelf": "رف الأدغال",
  "block.minecraft.jungle_sign": "لافتة من الأدغال",
  "block.minecraft.jungle_slab": "بلاطة الأدغال",
  "block.minecraft.jungle_stairs": "درج الأدغال",
  "block.minecraft.jungle_trapdoor": "باب أرضي من خشب الأدغال",
  "block.minecraft.jungle_wall_hanging_sign": "لافتة جدارية من خشب الأدغال معلقة",
  "block.minecraft.jungle_wall_sign": "لافتة جدارية من الأدغال",
  "block.minecraft.jungle_wood": "خشب الأدغال",
  "block.minecraft.kelp": "عشب البحر",
  "block.minecraft.kelp_plant": "نبات عشب البحر",
  "block.minecraft.ladder": "سلم",
  "block.minecraft.lantern": "فانوس",
  "block.minecraft.lapis_block": "كتلة لازورد",
  "block.minecraft.lapis_ore": "خام اللازورد",
  "block.minecraft.large_amethyst_bud": "برعم أماثيست كبير",
  "block.minecraft.large_fern": "سرخس كبيرة",
  "block.minecraft.lava": "حمم بركانية",
  "block.minecraft.lava_cauldron": "قدر حمم بركانية",
  "block.minecraft.leaf_litter": "فضلات الأوراق",
  "block.minecraft.lectern": "منصة القراءة",
  "block.minecraft.lever": "مقبض",
  "block.minecraft.light": "ضوء",
  "block.minecraft.light_blue_banner": "راية زرقاء فاتحة",
  "block.minecraft.light_blue_bed": "سرير أزرق فاتح",
  "block.minecraft.light_blue_candle": "شمعة زرقاء فاتحة",
  "block.minecraft.light_blue_candle_cake": "كعكة مع شمعة زرقاء فاتحة",
  "block.minecraft.light_blue_carpet": "سجاد أزرق الفاتح",
  "block.minecraft.light_blue_concrete": "أسمنت أزرق فاتح",
  "block.minecraft.light_blue_concrete_powder": "مسحوق أسمنت أزرق فاتح",
  "block.minecraft.light_blue_glazed_terracotta": "طين المزجج الأزرق الفاتح",
  "block.minecraft.light_blue_shulker_box": "صندوق شلكر أزرق فاتح",
  "block.minecraft.light_blue_stained_glass": "زجاج ازرق فاتح",
  "block.minecraft.light_blue_stained_glass_pane": "لوح زجاجي سماوي",
  "block.minecraft.light_blue_terracotta": "طين النضيج الأزرق الفاتح",
  "block.minecraft.light_blue_wool": "صوف أزرق فاتح",
  "block.minecraft.light_gray_banner": "راية رمادية فاتحة",
  "block.minecraft.light_gray_bed": "سرير رمادي فاتح",
  "block.minecraft.light_gray_candle": "شمعة رمادية فاتحة",
  "block.minecraft.light_gray_candle_cake": "كعكة مع شمعة رمادية فاتحة",
  "block.minecraft.light_gray_carpet": "سجاد رمادي فاتح",
  "block.minecraft.light_gray_concrete": "أسمنت رمادي فاتح",
  "block.minecraft.light_gray_concrete_powder": "مسحوق أسمنت رمادي فاتح",
  "block.minecraft.light_gray_glazed_terracotta": "طين المزجج الرمادي الفاتح",
  "block.minecraft.light_gray_shulker_box": "صندوق شلكر رمادي فاتح",
  "block.minecraft.light_gray_stained_glass": "زجاج رمادي فاتح",
  "block.minecraft.light_gray_stained_glass_pane": "لوح زجاجي رمادي فاتح",
  "block.minecraft.light_gray_terracotta": "طين النضيج الرمادي الفاتح",
  "block.minecraft.light_gray_wool": "صوف رمادي فاتح",
  "block.minecraft.light_weighted_pressure_plate": "صفيحة ضغط خفيفة الوزن",
  "block.minecraft.lightning_rod": "عصا البرق",
  "block.minecraft.lilac": "ليلك",
  "block.minecraft.lily_of_the_valley": "زنبق الوادي",
  "block.minecraft.lily_pad": "زنبق الماء",
  "block.minecraft.lime_banner": "راية ليمونية",
  "block.minecraft.lime_bed": "سرير ليموني",
  "block.minecraft.lime_candle": "شمعة ليمونية",
  "block.minecraft.lime_candle_cake": "كعكة مع شمعة خضراء فاتحة",
  "block.minecraft.lime_carpet": "سجاد ليموني",
  "block.minecraft.lime_concrete": "أسمنت ليموني",
  "block.minecraft.lime_concrete_powder": "مسحوق أسمنت ليموني",
  "block.minecraft.lime_glazed_terracotta": "طين المزجج الليموني",
  "block.minecraft.lime_shulker_box": "صندوق شلكر ليموني",
  "block.minecraft.lime_stained_glass": "زجاج ليموني",
  "block.minecraft.lime_stained_glass_pane": "لوح زجاجي ليموني",
  "block.minecraft.lime_terracotta": "طين النضيج الليموني",
  "block.minecraft.lime_wool": "صوف ليموني",
  "block.minecraft.lodestone": "حجر المغناطيس",
  "block.minecraft.loom": "منسج",
  "block.minecraft.magenta_banner": "راية أرجوانية",
  "block.minecraft.magenta_bed": "سرير أرجواني",
  "block.minecraft.magenta_candle": "شمعة أرجوانية",
  "block.minecraft.magenta_candle_cake": "كعكة مع شمعة أرجوانية",
  "block.minecraft.magenta_carpet": "سجاد أرجواني",
  "block.minecraft.magenta_concrete": "أسمنت أرجواني",
  "block.minecraft.magenta_concrete_powder": "مسحوق أسمنت أرجواني",
  "block.minecraft.magenta_glazed_terracotta": "طين المزجج الأرجواني",
  "block.minecraft.magenta_shulker_box": "صندوق شلكر أرجواني",
  "block.minecraft.magenta_stained_glass": "زجاج أرجواني",
  "block.minecraft.magenta_stained_glass_pane": "لوح زجاجي أرجواني",
  "block.minecraft.magenta_terracotta": "طين النضيج الأرجواني",
  "block.minecraft.magenta_wool": "صوف أرجواني",
  "block.minecraft.magma_block": "كتلة الصهارة",
  "block.minecraft.mangrove_button": "زر المانغروف",
  "block.minecraft.mangrove_door": "باب المانغروف",
  "block.minecraft.mangrove_fence": "سياج المانغروف",
  "block.minecraft.mangrove_fence_gate": "باب سياج المانغروف",
  "block.minecraft.mangrove_hanging_sign": "لافتة المانغروف معلقة",
  "block.minecraft.mangrove_leaves": "أوراق المانغروف",
  "block.minecraft.mangrove_log": "جذع المانغروف",
  "block.minecraft.mangrove_planks": "ألواح خشب المانغروف",
  "block.minecraft.mangrove_pressure_plate": "صفيحة ضغط خشب المانغروف",
  "block.minecraft.mangrove_propagule": "برعم المانغروف",
  "block.minecraft.mangrove_roots": "جذور المانغروف",
  "block.minecraft.mangrove_shelf": "رف المانغروف",
  "block.minecraft.mangrove_sign": "لافتة المانغروف",
  "block.minecraft.mangrove_slab": "بلاطة المانغروف",
  "block.minecraft.mangrove_stairs": "درج المانغروف",
  "block.minecraft.mangrove_trapdoor": "باب أرضي من خشب المانغروف",
  "block.minecraft.mangrove_wall_hanging_sign": "لافتة جدارية من المانغروف معلقة",
  "block.minecraft.mangrove_wall_sign": "لافتة جدارية من المانغروف",
  "block.minecraft.mangrove_wood": "خشب المانغروف",
  "block.minecraft.medium_amethyst_bud": "برعم أماثيست متوسط",
  "block.minecraft.melon": "بطيخة",
  "block.minecraft.melon_stem": "جذع بطيخ",
  "block.minecraft.moss_block": "كتلة طحلب",
  "block.minecraft.moss_carpet": "سجادة طحلب",
  "block.minecraft.mossy_cobblestone": "حصاة رصف مطحلبة",
  "block.minecraft.mossy_cobblestone_slab": "بلاطة حصاة الرصف المطلحبة",
  "block.minecraft.mossy_cobblestone_stairs": "درج حصاة الرصف المطلحبة",
  "block.minecraft.mossy_cobblestone_wall": "جدار حصاة رصف مطحلب",
  "block.minecraft.mossy_stone_brick_slab": "بلاطة طوب حجري مطحلب",
  "block.minecraft.mossy_stone_brick_stairs": "درج طوب حجري مطحلب",
  "block.minecraft.mossy_stone_brick_wall": "جدار طوب حجري مطحلب",
  "block.minecraft.mossy_stone_bricks": "طوب حجري مطحلب",
  "block.minecraft.moving_piston": "مكبس متحرك",
  "block.minecraft.mud": "وحل",
  "block.minecraft.mud_brick_slab": "بلاطة طوب الوحل",
  "block.minecraft.mud_brick_stairs": "درج من طوب الوحل",
  "block.minecraft.mud_brick_wall": "جدار طوب الوحل",
  "block.minecraft.mud_bricks": "طوب الوحل",
  "block.minecraft.muddy_mangrove_roots": "جذور المانغروف الموحلة",
  "block.minecraft.mushroom_stem": "جذع الفطر",
  "block.minecraft.mycelium": "أفطورة",
  "block.minecraft.nether_brick_fence": "سياج طوب النذر",
  "block.minecraft.nether_brick_slab": "بلاطة طوب النذر",
  "block.minecraft.nether_brick_stairs": "درج طوب النذر",
  "block.minecraft.nether_brick_wall": "جدار طوب النذر",
  "block.minecraft.nether_bricks": "طوب النذر",
  "block.minecraft.nether_gold_ore": "خام ذهب النذر",
  "block.minecraft.nether_portal": "بوابة النذر",
  "block.minecraft.nether_quartz_ore": "خام الكوارتز ",
  "block.minecraft.nether_sprouts": "براعم النذر",
  "block.minecraft.nether_wart": "ثؤلول النذر",
  "block.minecraft.nether_wart_block": "كتلة ثؤلول النذر",
  "block.minecraft.netherite_block": "كتلة من النذرايت",
  "block.minecraft.netherrack": "نذرراك",
  "block.minecraft.note_block": "كتلة النوتة",
  "block.minecraft.oak_button": "زر البلوط",
  "block.minecraft.oak_door": "باب البلوط",
  "block.minecraft.oak_fence": "سياج البلوط",
  "block.minecraft.oak_fence_gate": "بوابة سياج البلوط",
  "block.minecraft.oak_hanging_sign": "لافتة البلوط معلقة",
  "block.minecraft.oak_leaves": "أوراق البلوط",
  "block.minecraft.oak_log": "جذع البلوط",
  "block.minecraft.oak_planks": "ألواح خشب البلوط",
  "block.minecraft.oak_pressure_plate": "صفيحة ضغط خشب البلوط",
  "block.minecraft.oak_sapling": "شتلة البلوط",
  "block.minecraft.oak_shelf": "رف البلوط",
  "block.minecraft.oak_sign": "لافتة من البلوط",
  "block.minecraft.oak_slab": "بلاطة البلوط",
  "block.minecraft.oak_stairs": "درج البلوط",
  "block.minecraft.oak_trapdoor": "باب أرضي من خشب البلوط",
  "block.minecraft.oak_wall_hanging_sign": "لافتة البلوط معلقة",
  "block.minecraft.oak_wall_sign": "لافتة جدارية من البلوط",
  "block.minecraft.oak_wood": "خشب البلوط",
  "block.minecraft.observer": "المراقب",
  "block.minecraft.obsidian": "سبج",
  "block.minecraft.ochre_froglight": "ضوء الضفدع البرتقالي",
  "block.minecraft.ominous_banner": "راية مشؤومة",
  "block.minecraft.open_eyeblossom": "زهرة عين مفتوحة",
  "block.minecraft.orange_banner": "راية برتقالية",
  "block.minecraft.orange_bed": "سرير برتقالي",
  "block.minecraft.orange_candle": "شمعة برتقالية",
  "block.minecraft.orange_candle_cake": "كعكة مع شمعة برتقالية",
  "block.minecraft.orange_carpet": "سجاد برتقالي",
  "block.minecraft.orange_concrete": "أسمنت برتقالي",
  "block.minecraft.orange_concrete_powder": "مسحوق أسمنت برتقالي",
  "block.minecraft.orange_glazed_terracotta": "طين المزجج البرتقالي",
  "block.minecraft.orange_shulker_box": "صندوق شلكر برتقالي",
  "block.minecraft.orange_stained_glass": "زجاج برتقالي",
  "block.minecraft.orange_stained_glass_pane": "لوح زجاجي برتقالي",
  "block.minecraft.orange_terracotta": "طين النضيج البرتقالي",
  "block.minecraft.orange_tulip": "توليب برتقالي",
  "block.minecraft.orange_wool": "صوف برتقالي",
  "block.minecraft.oxeye_daisy": "أقحوان المروج",
  "block.minecraft.oxidized_chiseled_copper": "نحاس منحوت مؤكسد",
  "block.minecraft.oxidized_copper": "نحاس مؤكسد",
  "block.minecraft.oxidized_copper_bars": "قضبان نحاسية مؤكسدة",
  "block.minecraft.oxidized_copper_bulb": "مصباح نحاسي مؤكسد",
  "block.minecraft.oxidized_copper_chain": "سلسلة نحاسية مؤكسدة",
  "block.minecraft.oxidized_copper_chest": "صندوق النحاس مؤكسد",
  "block.minecraft.oxidized_copper_door": "باب نحاسي مؤكسد",
  "block.minecraft.oxidized_copper_golem_statue": "تمثال رجل نحاسي مؤكسد",
  "block.minecraft.oxidized_copper_grate": "شبك نحاسي مؤكسد",
  "block.minecraft.oxidized_copper_lantern": "فانوس نحاسي مؤكسد",
  "block.minecraft.oxidized_copper_trapdoor": "باب أرضي نحاسي مؤكسد",
  "block.minecraft.oxidized_cut_copper": "نحاس مقطع مؤكسد",
  "block.minecraft.oxidized_cut_copper_slab": "بلاطة نحاس مقطع مؤكسد",
  "block.minecraft.oxidized_cut_copper_stairs": "درج نحاس مقطع مؤكسد",
  "block.minecraft.oxidized_lightning_rod": "عصا البرق المؤكسدة",
  "block.minecraft.packed_ice": "جليد معبأ",
  "block.minecraft.packed_mud": "وحل مضغوط",
  "block.minecraft.pale_hanging_moss": "طحلب معلق شاحب",
  "block.minecraft.pale_moss_block": "كتلة طحلب شاحب",
  "block.minecraft.pale_moss_carpet": "سجادة طحلب شاحب",
  "block.minecraft.pale_oak_button": "زر البلوط الشاحب",
  "block.minecraft.pale_oak_door": "باب البلوط الشاحب",
  "block.minecraft.pale_oak_fence": "سياج البلوط الشاحب",
  "block.minecraft.pale_oak_fence_gate": "بوابة سياج البلوط الشاحب",
  "block.minecraft.pale_oak_hanging_sign": "لافتة البلوط الشاحب معلقة",
  "block.minecraft.pale_oak_leaves": "أوراق البلوط الشاحب",
  "block.minecraft.pale_oak_log": "جذع البلوط الشاحب",
  "block.minecraft.pale_oak_planks": "ألواح خشب البلوط الشاحب",
  "block.minecraft.pale_oak_pressure_plate": "صفيحة ضغط خشب البلوط الشاحب",
  "block.minecraft.pale_oak_sapling": "شتلة البلوط الشاحب",
  "block.minecraft.pale_oak_shelf": "رف البلوط الشاحب",
  "block.minecraft.pale_oak_sign": "لافتة من البلوط الشاحب",
  "block.minecraft.pale_oak_slab": "بلاطة البلوط الشاحب",
  "block.minecraft.pale_oak_stairs": "درج البلوط الشاحب",
  "block.minecraft.pale_oak_trapdoor": "باب أرضي من خشب البلوط الشاحب",
  "block.minecraft.pale_oak_wall_hanging_sign": "لافتة جدارية من البلوط الشاحب معلقة",
  "block.minecraft.pale_oak_wall_sign": "لافتة من البلوط الشاحب",
  "block.minecraft.pale_oak_wood": "خشب البلوط الشاحب",
  "block.minecraft.pearlescent_froglight": "ضوء الضفدع أللؤلؤي",
  "block.minecraft.peony": "عود الصليب",
  "block.minecraft.petrified_oak_slab": "بلاطة خشب البلوط المتحجرة",
  "block.minecraft.piglin_head": "رأس الخنزير المحارب",
  "block.minecraft.piglin_wall_head": "رأس بيجلن حائطي",
  "block.minecraft.pink_banner": "راية وردية",
  "block.minecraft.pink_bed": "سرير وردي",
  "block.minecraft.pink_candle": "شمعة وردية",
  "block.minecraft.pink_candle_cake": "كعكة مع شمعة وردية",
  "block.minecraft.pink_carpet": "سجاد وردي",
  "block.minecraft.pink_concrete": "أسمنت وردي",
  "block.minecraft.pink_concrete_powder": "مسحوق أسمنت وردي",
  "block.minecraft.pink_glazed_terracotta": "طين المزجج الوردي",
  "block.minecraft.pink_petals": "بتلات وردية",
  "block.minecraft.pink_shulker_box": "صندوق شلكر زهري",
  "block.minecraft.pink_stained_glass": "زجاج وردي",
  "block.minecraft.pink_stained_glass_pane": "لوح زجاجي وردي",
  "block.minecraft.pink_terracotta": "طين النضيج الوردي",
  "block.minecraft.pink_tulip": "توليب وردي",
  "block.minecraft.pink_wool": "صوف وردي",
  "block.minecraft.piston": "مكبس",
  "block.minecraft.piston_head": "رأس المكبس",
  "block.minecraft.pitcher_crop": "جرة المحاصيل",
  "block.minecraft.pitcher_plant": "جرة النبات",
  "block.minecraft.player_head": "رأس لاعب",
  "block.minecraft.player_head.named": "رأس %s",
  "block.minecraft.player_wall_head": "رأس لاعب حائطي",
  "block.minecraft.podzol": "بودزول",
  "block.minecraft.pointed_dripstone": "حجر تنقيط مدبب",
  "block.minecraft.polished_andesite": "أنديسايت مصقول",
  "block.minecraft.polished_andesite_slab": "بلاطة أنديسايت مصقول",
  "block.minecraft.polished_andesite_stairs": "درج أنديسايت مصقول",
  "block.minecraft.polished_basalt": "بازلت مصقول",
  "block.minecraft.polished_blackstone": "حجر أسود مصقول",
  "block.minecraft.polished_blackstone_brick_slab": "بلاطة طوب حجر أسود مصقول",
  "block.minecraft.polished_blackstone_brick_stairs": "جدار طوب حجر أسود مصقول",
  "block.minecraft.polished_blackstone_brick_wall": "جدار حجر أسود مصقول",
  "block.minecraft.polished_blackstone_bricks": "طوب حجر أسود مصقول",
  "block.minecraft.polished_blackstone_button": "زر من حجر أسود مصقول",
  "block.minecraft.polished_blackstone_pressure_plate": "صفيحة ضغط حجر أسود مصقول",
  "block.minecraft.polished_blackstone_slab": "بلاطة حجر أسود مصقول",
  "block.minecraft.polished_blackstone_stairs": "درج حجر أسود مصقول",
  "block.minecraft.polished_blackstone_wall": "جدار حجر أسود مصقول",
  "block.minecraft.polished_deepslate": "حجر عميق مصقول",
  "block.minecraft.polished_deepslate_slab": "بلاطة حجر عميق مصقول",
  "block.minecraft.polished_deepslate_stairs": "درج حجر عميق مصقول",
  "block.minecraft.polished_deepslate_wall": "جدار حجر عميق مصقول",
  "block.minecraft.polished_diorite": "ديوريت مصقول",
  "block.minecraft.polished_diorite_slab": "بلاطة ديوريت مصقول",
  "block.minecraft.polished_diorite_stairs": "درج ديوريت مصقول",
  "block.minecraft.polished_granite": "جرانيت مصقول",
  "block.minecraft.polished_granite_slab": "بلاطة جرانيت مصقول",
  "block.minecraft.polished_granite_stairs": "درج جرانيت مصقول",
  "block.minecraft.polished_tuff": "حجر بركاني مصقول",
  "block.minecraft.polished_tuff_slab": "كتلة حجارة بركانية مصقولة",
  "block.minecraft.polished_tuff_stairs": "درجات حجر بركانية مصقولة",
  "block.minecraft.polished_tuff_wall": "جدار بركاني مصقول",
  "block.minecraft.poppy": "خشخاش",
  "block.minecraft.potatoes": "بطاطا",
  "block.minecraft.potted_acacia_sapling": "شتلة السنط في وعاء",
  "block.minecraft.potted_allium": "زهرة الثوم في وعاء",
  "block.minecraft.potted_azalea_bush": "أزاليا في وعاء",
  "block.minecraft.potted_azure_bluet": "الزهرة اللازوردية الزرقاء في وعاء",
  "block.minecraft.potted_bamboo": "قصب الخيزران في وعاء",
  "block.minecraft.potted_birch_sapling": "شتلة البتولا في وعاء",
  "block.minecraft.potted_blue_orchid": "الأوركيد الأزرق في وعاء",
  "block.minecraft.potted_brown_mushroom": "فطر بني في وعاء",
  "block.minecraft.potted_cactus": "صبار في وعاء",
  "block.minecraft.potted_cherry_sapling": "شتلة الكرز في وعاء",
  "block.minecraft.potted_closed_eyeblossom": "زهرة عين مغلقة في وعاء",
  "block.minecraft.potted_cornflower": "وردة الذرة في وعاء",
  "block.minecraft.potted_crimson_fungus": "فطر قرمزي في وعاء",
  "block.minecraft.potted_crimson_roots": "جذور قرمزية في وعاء",
  "block.minecraft.potted_dandelion": "الهندباء في وعاء",
  "block.minecraft.potted_dark_oak_sapling": "شتلة البلوط الداكن في وعاء",
  "block.minecraft.potted_dead_bush": "شجيرة ميتة في وعاء",
  "block.minecraft.potted_fern": "سرخس في وعاء",
  "block.minecraft.potted_flowering_azalea_bush": "أزاليا مزهرة في وعاء",
  "block.minecraft.potted_golden_dandelion": "هندباء ذهبية مزروعة",
  "block.minecraft.potted_jungle_sapling": "شتلة الأدغال في وعاء",
  "block.minecraft.potted_lily_of_the_valley": "زنبق الوادي في وعاء",
  "block.minecraft.potted_mangrove_propagule": "برعم المانغروف في وعاء",
  "block.minecraft.potted_oak_sapling": "شتلة البلوط في وعاء",
  "block.minecraft.potted_open_eyeblossom": "زهرة عين مفتوحة في وعاء",
  "block.minecraft.potted_orange_tulip": "توليب برتقالي في وعاء",
  "block.minecraft.potted_oxeye_daisy": "أقحوان المروج في وعاء",
  "block.minecraft.potted_pale_oak_sapling": "شتلة البلوط الشاحب في وعاء",
  "block.minecraft.potted_pink_tulip": "توليب وردي في وعاء",
  "block.minecraft.potted_poppy": "الخشخاش في وعاء",
  "block.minecraft.potted_red_mushroom": "فطر أحمر في وعاء",
  "block.minecraft.potted_red_tulip": "توليب أحمر في وعاء",
  "block.minecraft.potted_spruce_sapling": "شتلة التنوب في وعاء",
  "block.minecraft.potted_torchflower": "وردة الشعلة في وعاء",
  "block.minecraft.potted_warped_fungus": "فطر عجيب في وعاء",
  "block.minecraft.potted_warped_roots": "جذور غريبة في وعاء",
  "block.minecraft.potted_white_tulip": "توليب أبيض في وعاء",
  "block.minecraft.potted_wither_rose": "زهرة الوذر في وعاء",
  "block.minecraft.powder_snow": "مسحوق الثلج",
  "block.minecraft.powder_snow_cauldron": "قدر مسحوق الثلج",
  "block.minecraft.powered_rail": "سكة حديدية تعمل بالطاقة",
  "block.minecraft.prismarine": "بريسمارين",
  "block.minecraft.prismarine_brick_slab": "بلاطة طوب البريسمارين",
  "block.minecraft.prismarine_brick_stairs": "درج طوب البريسمارين",
  "block.minecraft.prismarine_bricks": "طوب البريسمارين",
  "block.minecraft.prismarine_slab": "بلاطة بريسمارين",
  "block.minecraft.prismarine_stairs": "درج بريسمارين",
  "block.minecraft.prismarine_wall": "جدار بريسمارين",
  "block.minecraft.pumpkin": "يقطين",
  "block.minecraft.pumpkin_stem": "جذع يقطين",
  "block.minecraft.purple_banner": "راية بنفسجية",
  "block.minecraft.purple_bed": "سرير بنفسجي",
  "block.minecraft.purple_candle": "شمعة بنفسجية",
  "block.minecraft.purple_candle_cake": "كعكة مع شمعة بنفسجية",
  "block.minecraft.purple_carpet": "سجاد بنفسجي",
  "block.minecraft.purple_concrete": "أسمنت بنفسجي",
  "block.minecraft.purple_concrete_powder": "مسحوق أسمنت بنفسجي",
  "block.minecraft.purple_glazed_terracotta": "طين مزجج بنفسجي",
  "block.minecraft.purple_shulker_box": "صندوق شلكر بنفسجي",
  "block.minecraft.purple_stained_glass": "زجاج بنفسجي",
  "block.minecraft.purple_stained_glass_pane": "لوح زجاجي بنفسجي",
  "block.minecraft.purple_terracotta": "طين النضيج البنفسجي",
  "block.minecraft.purple_wool": "صوف بنفسجي",
  "block.minecraft.purpur_block": "كتلة بربر",
  "block.minecraft.purpur_pillar": "عمود بربر",
  "block.minecraft.purpur_slab": "بلاطة بربر",
  "block.minecraft.purpur_stairs": "درج بربر",
  "block.minecraft.quartz_block": "كتلة من الكوارتز",
  "block.minecraft.quartz_bricks": "طوب الكوارتز",
  "block.minecraft.quartz_pillar": "عمود كوارتز",
  "block.minecraft.quartz_slab": "بلاطة كوارتز",
  "block.minecraft.quartz_stairs": "درج كوارتز",
  "block.minecraft.rail": "سكة حديدية",
  "block.minecraft.raw_copper_block": "كتلة من النحاس الخام",
  "block.minecraft.raw_gold_block": "كتلة ذهب خام",
  "block.minecraft.raw_iron_block": "كتلة من الحديد الخام",
  "block.minecraft.red_banner": "راية حمراء",
  "block.minecraft.red_bed": "سرير أحمر",
  "block.minecraft.red_candle": "شمعة حمراء",
  "block.minecraft.red_candle_cake": "كعكة مع شمعة حمراء",
  "block.minecraft.red_carpet": "سجاد أحمر",
  "block.minecraft.red_concrete": "أسمنت أحمر",
  "block.minecraft.red_concrete_powder": "مسحوق أسمنت أحمر",
  "block.minecraft.red_glazed_terracotta": "طين المزجج الأحمر",
  "block.minecraft.red_mushroom": "فطر أحمر",
  "block.minecraft.red_mushroom_block": "كتلة فطر أحمر",
  "block.minecraft.red_nether_brick_slab": "بلاطة طوب النذر الأحمر",
  "block.minecraft.red_nether_brick_stairs": "درج طوب النذر الأحمر",
  "block.minecraft.red_nether_brick_wall": "جدار طوب النذر الأحمر",
  "block.minecraft.red_nether_bricks": "طوب النذر الأحمر",
  "block.minecraft.red_sand": "رمل أحمر",
  "block.minecraft.red_sandstone": "حجر رملي أحمر",
  "block.minecraft.red_sandstone_slab": "بلاطة حجر رملي أحمر",
  "block.minecraft.red_sandstone_stairs": "درج حجر رملي أحمر",
  "block.minecraft.red_sandstone_wall": "جدار حجر رملي أحمر",
  "block.minecraft.red_shulker_box": "صندوق شلكر أحمر",
  "block.minecraft.red_stained_glass": "زجاج أحمر",
  "block.minecraft.red_stained_glass_pane": "لوح زجاجي أحمر",
  "block.minecraft.red_terracotta": "طين النضيج الأحمر",
  "block.minecraft.red_tulip": "توليب أحمر",
  "block.minecraft.red_wool": "صوف أحمر",
  "block.minecraft.redstone_block": "كتلة من الريدستون",
  "block.minecraft.redstone_lamp": "مصباح الريدستون",
  "block.minecraft.redstone_ore": "خام الريدستون",
  "block.minecraft.redstone_torch": "شعلة الريدستون",
  "block.minecraft.redstone_wall_torch": "شعلة ريدستون جدارية",
  "block.minecraft.redstone_wire": "سلك ريدستون",
  "block.minecraft.reinforced_deepslate": "حجر عميق مدعّم",
  "block.minecraft.repeater": "مكرر الريدستون",
  "block.minecraft.repeating_command_block": "كتلة الأوامر المكرِّرة",
  "block.minecraft.resin_block": "كتلة من الراتنج",
  "block.minecraft.resin_brick_slab": "بلاطة طوب الراتنج",
  "block.minecraft.resin_brick_stairs": "درج طوب الراتنج",
  "block.minecraft.resin_brick_wall": "جدار طوب الراتنج",
  "block.minecraft.resin_bricks": "طوب الراتنج",
  "block.minecraft.resin_clump": "مجموعة الراتنج",
  "block.minecraft.respawn_anchor": "مرساة إعادة الإحياء",
  "block.minecraft.rooted_dirt": "تراب متجذر",
  "block.minecraft.rose_bush": "شجيرة ورد",
  "block.minecraft.sand": "رمل",
  "block.minecraft.sandstone": "حجر رملي",
  "block.minecraft.sandstone_slab": "بلاطة حجر رملي",
  "block.minecraft.sandstone_stairs": "درج حجر رملي",
  "block.minecraft.sandstone_wall": "جدار حجر رملي",
  "block.minecraft.scaffolding": "سقالة",
  "block.minecraft.sculk": "سكالك",
  "block.minecraft.sculk_catalyst": "محفز السكالك",
  "block.minecraft.sculk_sensor": "مستشعر السكالك",
  "block.minecraft.sculk_shrieker": "صارخ السكالك",
  "block.minecraft.sculk_vein": "عرق السكالك",
  "block.minecraft.sea_lantern": "مصباح البحر",
  "block.minecraft.sea_pickle": "خيار البحر",
  "block.minecraft.seagrass": "أعشاب البحر",
  "block.minecraft.set_spawn": "تم تعيين نقطة إعادة الإحياء",
  "block.minecraft.short_dry_grass": "عشب جاف قصير",
  "block.minecraft.short_grass": "عشب قصير",
  "block.minecraft.shroomlight": "ضوء الفطر",
  "block.minecraft.shulker_box": "صندوق الشلكر",
  "block.minecraft.skeleton_skull": "جمجمة هيكل عظمي",
  "block.minecraft.skeleton_wall_skull": "جمجمة هيكل عظمي حائطية",
  "block.minecraft.slime_block": "كتلة اللزج",
  "block.minecraft.small_amethyst_bud": "برعم أماثيست صغير",
  "block.minecraft.small_dripleaf": "ورقة تقطير صغيرة",
  "block.minecraft.smithing_table": "منضدة الحدادة",
  "block.minecraft.smoker": "مدخن",
  "block.minecraft.smooth_basalt": "بازلت ناعم",
  "block.minecraft.smooth_quartz": "كتلة كوارتز ناعمة",
  "block.minecraft.smooth_quartz_slab": "بلاطة كوارتز ناعمة",
  "block.minecraft.smooth_quartz_stairs": "درج كوارتز ناعم",
  "block.minecraft.smooth_red_sandstone": "حجر رملي أحمر أملس",
  "block.minecraft.smooth_red_sandstone_slab": "بلاطة حجر رملي أحمر أملس",
  "block.minecraft.smooth_red_sandstone_stairs": "درج حجر رملي أحمر أملس",
  "block.minecraft.smooth_sandstone": "حجر رملي أملس",
  "block.minecraft.smooth_sandstone_slab": "بلاطة حجر رملي أملس",
  "block.minecraft.smooth_sandstone_stairs": "درج حجر رملي أملس",
  "block.minecraft.smooth_stone": "حجر أملس",
  "block.minecraft.smooth_stone_slab": "بلاطة حجر أملس",
  "block.minecraft.sniffer_egg": "بيضة المشمم",
  "block.minecraft.snow": "ثلج",
  "block.minecraft.snow_block": "كتلة ثلج",
  "block.minecraft.soul_campfire": "موقد نار الروح",
  "block.minecraft.soul_fire": "نار الروح",
  "block.minecraft.soul_lantern": "فانوس الروح",
  "block.minecraft.soul_sand": "رمل الروح",
  "block.minecraft.soul_soil": "تربة الروح",
  "block.minecraft.soul_torch": "شعلة روحية",
  "block.minecraft.soul_wall_torch": "شعلة جدارية روحية",
  "block.minecraft.spawn.not_valid": "ليس لديك سرير أو مرساة إعادة إحياء مشحونة، أو أنه تم سده",
  "block.minecraft.spawner": "مولد الوحوش",
  "block.minecraft.spawner.desc1": "التفاعل مع بيضة المخلوقات:",
  "block.minecraft.spawner.desc2": "يحدد نوع المخلوق",
  "block.minecraft.sponge": "إسفنج",
  "block.minecraft.spore_blossom": "زهرة بوغ",
  "block.minecraft.spruce_button": "زر التنوب",
  "block.minecraft.spruce_door": "باب التنوب",
  "block.minecraft.spruce_fence": "سياج التنوب",
  "block.minecraft.spruce_fence_gate": "بوابة سياج التنوب",
  "block.minecraft.spruce_hanging_sign": "لافتة خشب التنوب معلقة",
  "block.minecraft.spruce_leaves": "أوراق التنوب",
  "block.minecraft.spruce_log": "جذع التنوب",
  "block.minecraft.spruce_planks": "ألواح خشب التنوب",
  "block.minecraft.spruce_pressure_plate": "صفيحة ضغط خشب التنوب",
  "block.minecraft.spruce_sapling": "شتلة التنوب",
  "block.minecraft.spruce_shelf": "رف التنوب",
  "block.minecraft.spruce_sign": "لافتة خشب التنوب",
  "block.minecraft.spruce_slab": "بلاطة التنوب",
  "block.minecraft.spruce_stairs": "درج التنوب",
  "block.minecraft.spruce_trapdoor": "باب أرضي من خشب التنوب",
  "block.minecraft.spruce_wall_hanging_sign": "لافتة جدارية من خشب التنوب معلقة",
  "block.minecraft.spruce_wall_sign": "لافتة جدارية من التنوب",
  "block.minecraft.spruce_wood": "خشب التنوب",
  "block.minecraft.sticky_piston": "مكبس لزج",
  "block.minecraft.stone": "حجر",
  "block.minecraft.stone_brick_slab": "بلاطة طوب حجري",
  "block.minecraft.stone_brick_stairs": "درج من الطوب الحجري",
  "block.minecraft.stone_brick_wall": "جدار طوب حجري",
  "block.minecraft.stone_bricks": "طوب حجري",
  "block.minecraft.stone_button": "زر حجري",
  "block.minecraft.stone_pressure_plate": "صفيحة ضغط حجرية",
  "block.minecraft.stone_slab": "بلاطة حجرية",
  "block.minecraft.stone_stairs": "درج حجري",
  "block.minecraft.stonecutter": "قاطع الحجارة",
  "block.minecraft.stripped_acacia_log": "جذع السنط منزوع اللحاء",
  "block.minecraft.stripped_acacia_wood": "خشب السنط منزوع اللحاء",
  "block.minecraft.stripped_bamboo_block": "كتلة من الخيزران المنزوع",
  "block.minecraft.stripped_birch_log": "جذع البتولا منزوع اللحاء",
  "block.minecraft.stripped_birch_wood": "خشب البتولا منزوع اللحاء",
  "block.minecraft.stripped_cherry_log": "جذع الكرز منزوع اللحاء",
  "block.minecraft.stripped_cherry_wood": "خشب الكرز منزوع اللحاء",
  "block.minecraft.stripped_crimson_hyphae": "لحاء قرمزي منزوعة",
  "block.minecraft.stripped_crimson_stem": "جذع قرمزي منزوع اللحاء",
  "block.minecraft.stripped_dark_oak_log": "جذع البلوط الداكن منزوع اللحاء",
  "block.minecraft.stripped_dark_oak_wood": "خشب البلوط الداكن منزوع اللحاء",
  "block.minecraft.stripped_jungle_log": "جذع الأدغال منزوع اللحاء",
  "block.minecraft.stripped_jungle_wood": "خشب الأدغال منزوع اللحاء",
  "block.minecraft.stripped_mangrove_log": "جذع المانغروف منزوع اللحاء",
  "block.minecraft.stripped_mangrove_wood": "خشب المانغروف منزوع اللحاء",
  "block.minecraft.stripped_oak_log": "جذع البلوط منزوع اللحاء",
  "block.minecraft.stripped_oak_wood": "خشب البلوط منزوع اللحاء",
  "block.minecraft.stripped_pale_oak_log": "جذع البلوط الشاحب منزوع اللحاء",
  "block.minecraft.stripped_pale_oak_wood": "خشب البلوط الشاحب منزوع اللحاء",
  "block.minecraft.stripped_spruce_log": "جذع التنوب منزوع اللحاء",
  "block.minecraft.stripped_spruce_wood": "خشب التنوب منزوع اللحاء",
  "block.minecraft.stripped_warped_hyphae": "خيوط فطرية عجيبة منزوعة اللحاء",
  "block.minecraft.stripped_warped_stem": "جذع عجيب منزوع اللحاء",
  "block.minecraft.structure_block": "كتلة الهيكل",
  "block.minecraft.structure_void": "فراغ الهيكل",
  "block.minecraft.sugar_cane": "قصب السكر",
  "block.minecraft.sunflower": "عباد الشمس",
  "block.minecraft.suspicious_gravel": "حصى الشك",
  "block.minecraft.suspicious_sand": "رمل مثير",
  "block.minecraft.sweet_berry_bush": "شجيرة التوت الحلو",
  "block.minecraft.tall_dry_grass": "عشب جاف طويل",
  "block.minecraft.tall_grass": "عشب طويل",
  "block.minecraft.tall_seagrass": "أعشاب البحر الطويلة",
  "block.minecraft.target": "هدف",
  "block.minecraft.terracotta": "طين النضيج",
  "block.minecraft.test_block": "كتلة الاختبار",
  "block.minecraft.test_instance_block": "كتلة مثيل الاختبار",
  "block.minecraft.tinted_glass": "زجاج مظلل",
  "block.minecraft.tnt": "ديناميت",
  "block.minecraft.tnt.disabled": "انفجارات الديناميت معطلة",
  "block.minecraft.torch": "شعلة",
  "block.minecraft.torchflower": "وردة الشعلة",
  "block.minecraft.torchflower_crop": "محصول وردة الشعلة",
  "block.minecraft.trapped_chest": "صندوق مفخخ",
  "block.minecraft.trial_spawner": "مولد الاختبار",
  "block.minecraft.tripwire": "سلك المصيدة",
  "block.minecraft.tripwire_hook": "خطاف سلك المصيدة",
  "block.minecraft.tube_coral": "مرجان أنبوبي",
  "block.minecraft.tube_coral_block": "كتلة مرجان أنبوبي",
  "block.minecraft.tube_coral_fan": "شعاب مرجان أنبوبي",
  "block.minecraft.tube_coral_wall_fan": "شعاب مرجان أنبوبي جداري",
  "block.minecraft.tuff": "طفة",
  "block.minecraft.tuff_brick_slab": "كتلة طوب من الحجر البركاني",
  "block.minecraft.tuff_brick_stairs": "درجات طوب حجر بركاني",
  "block.minecraft.tuff_brick_wall": "جدار طوب حجر بركاني",
  "block.minecraft.tuff_bricks": "طوب حجر بركاني",
  "block.minecraft.tuff_slab": "كتلة حجارة بركانية",
  "block.minecraft.tuff_stairs": "درجات حجارة بركانية",
  "block.minecraft.tuff_wall": "جدار حجر بركاني",
  "block.minecraft.turtle_egg": "بيضة سلحفاة",
  "block.minecraft.twisting_vines": "نبات متسلق ملتوي",
  "block.minecraft.twisting_vines_plant": "غرسة النبات المتسلق الملتوي",
  "block.minecraft.vault": "خزنة",
  "block.minecraft.verdant_froglight": "ضوء الضفدع الأخضر",
  "block.minecraft.vine": "نبات متسلق",
  "block.minecraft.void_air": "هواء الفراغ",
  "block.minecraft.wall_torch": "شعلة جدارية",
  "block.minecraft.warped_button": "زر عجيب",
  "block.minecraft.warped_door": "باب عجيب",
  "block.minecraft.warped_fence": "سياج عجيب",
  "block.minecraft.warped_fence_gate": "بوابة سياج عجيبة",
  "block.minecraft.warped_fungus": "فطر عجيب",
  "block.minecraft.warped_hanging_sign": "لافتة عجيبة معلقة",
  "block.minecraft.warped_hyphae": "خيوط فطرية عجيبة",
  "block.minecraft.warped_nylium": "نيليوم ازرق",
  "block.minecraft.warped_planks": "ألواح خشب عجيبة",
  "block.minecraft.warped_pressure_plate": "لوحة ضغط عجيبة",
  "block.minecraft.warped_roots": "جذور عجيبة",
  "block.minecraft.warped_shelf": "رف العجيب",
  "block.minecraft.warped_sign": "لافتة عجيبة",
  "block.minecraft.warped_slab": "بلاطة عجيبة",
  "block.minecraft.warped_stairs": "درج عجيب",
  "block.minecraft.warped_stem": "جذع عجيب",
  "block.minecraft.warped_trapdoor": "باب أرضي عجيب",
  "block.minecraft.warped_wall_hanging_sign": "لافتة جدارية عجيبة معلقة",
  "block.minecraft.warped_wall_sign": "لافتة جدارية عجيبة",
  "block.minecraft.warped_wart_block": "كتلة ثؤلول عجيبة",
  "block.minecraft.water": "ماء",
  "block.minecraft.water_cauldron": "قدر ماء",
  "block.minecraft.waxed_chiseled_copper": "نحاس منحوت مشمع",
  "block.minecraft.waxed_copper_bars": "قضبان نحاسية مشمعة",
  "block.minecraft.waxed_copper_block": "كتلة مشمعة من النحاس",
  "block.minecraft.waxed_copper_bulb": "مصباح نحاسي مشمع",
  "block.minecraft.waxed_copper_chain": "سلسلة نحاسية مشمعة",
  "block.minecraft.waxed_copper_chest": "صندوق نحاسي مشمع",
  "block.minecraft.waxed_copper_door": "باب نحاسي مشمع",
  "block.minecraft.waxed_copper_golem_statue": "تمثال رجل نحاسي مشمع",
  "block.minecraft.waxed_copper_grate": "شبك نحاسي مشمع",
  "block.minecraft.waxed_copper_lantern": "فانوس نحاسي مشمع",
  "block.minecraft.waxed_copper_trapdoor": "باب أرضي نحاسي مشمع",
  "block.minecraft.waxed_cut_copper": "نحاس مقطع مشمع",
  "block.minecraft.waxed_cut_copper_slab": "بلاطة نحاس مقطع مشمع",
  "block.minecraft.waxed_cut_copper_stairs": "درج نحاس مقطع مشمع",
  "block.minecraft.waxed_exposed_chiseled_copper": "نحاس منحوت مكشوف مشمع",
  "block.minecraft.waxed_exposed_copper": "نحاس مكشوف مشمع",
  "block.minecraft.waxed_exposed_copper_bars": "قضبان نحاسية مكشوفة مشمعة",
  "block.minecraft.waxed_exposed_copper_bulb": "مصباح نحاسي مكشوف مشمع",
  "block.minecraft.waxed_exposed_copper_chain": "سلسلة نحاسية مكشوفة مشمعة",
  "block.minecraft.waxed_exposed_copper_chest": "صندوق نحاسي مكشوف مشمع",
  "block.minecraft.waxed_exposed_copper_door": "باب نحاسي مكشوف مشمع",
  "block.minecraft.waxed_exposed_copper_golem_statue": "تمثال رجل نحاسي مكشوف مشمع",
  "block.minecraft.waxed_exposed_copper_grate": "شبك نحاسي مكشوف مشمع",
  "block.minecraft.waxed_exposed_copper_lantern": "فانوس نحاسي مكشوف مشمع",
  "block.minecraft.waxed_exposed_copper_trapdoor": "باب أرضي نحاسي مكشوف مشمع",
  "block.minecraft.waxed_exposed_cut_copper": "نحاس مقطع مكشوف مشمع",
  "block.minecraft.waxed_exposed_cut_copper_slab": "بلاطة نحاس مقطع مكشوف مشمع",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "درج نحاس مقطع مكشوف مشمع",
  "block.minecraft.waxed_exposed_lightning_rod": "عصا البرق المكشوفة المشمعة",
  "block.minecraft.waxed_lightning_rod": "عصا البرق المشمعة",
  "block.minecraft.waxed_oxidized_chiseled_copper": "نحاس منحوت مؤكسد مشمع",
  "block.minecraft.waxed_oxidized_copper": "نحاس مؤكسد مشمع",
  "block.minecraft.waxed_oxidized_copper_bars": "قضبان نحاسية مؤكسدة مشمعة",
  "block.minecraft.waxed_oxidized_copper_bulb": "مصباح نحاسي مؤكسد مشمع",
  "block.minecraft.waxed_oxidized_copper_chain": "سلسلة نحاسية مؤكسدة مشمعة",
  "block.minecraft.waxed_oxidized_copper_chest": "صندوق نحاسي مؤكسد مشمع",
  "block.minecraft.waxed_oxidized_copper_door": "باب نحاسي مؤكسد مشمع",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "تمثال رجل نحاسي مؤكسد مشمع",
  "block.minecraft.waxed_oxidized_copper_grate": "شبك نحاسي مؤكسد مشمع",
  "block.minecraft.waxed_oxidized_copper_lantern": "فانوس نحاسي مؤكسد مشمع",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "باب أرضي نحاسي مؤكسد مشمع",
  "block.minecraft.waxed_oxidized_cut_copper": "نحاس مقطع مؤكسد مشمع",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "بلاطة نحاس مقطع مؤكسد مشمع",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "درج نحاس مقطع مؤكسد مشمع",
  "block.minecraft.waxed_oxidized_lightning_rod": "عصا البرق المؤكسدة المشمعة",
  "block.minecraft.waxed_weathered_chiseled_copper": "نحاس منحوت مشمع معرض للجو",
  "block.minecraft.waxed_weathered_copper": "نحاس مشمع معرض للجو",
  "block.minecraft.waxed_weathered_copper_bars": "قضبان نحاسية مشمعة معرضة للجو",
  "block.minecraft.waxed_weathered_copper_bulb": "مصباح نحاسي مشمع معرض للجو",
  "block.minecraft.waxed_weathered_copper_chain": "سلسلة نحاسية مشمعة معرضة للجو",
  "block.minecraft.waxed_weathered_copper_chest": "صندوق نحاسي مشمع معرض للجو",
  "block.minecraft.waxed_weathered_copper_door": "باب نحاسي مشمع معرض للجو",
  "block.minecraft.waxed_weathered_copper_golem_statue": "تمثال رجل نحاسي مشمع معرض للجو",
  "block.minecraft.waxed_weathered_copper_grate": "شبك نحاسي مشمع معرض للجو",
  "block.minecraft.waxed_weathered_copper_lantern": "فانوس نحاسي مشمع معرض للجو",
  "block.minecraft.waxed_weathered_copper_trapdoor": "باب أرضي نحاسي مشمع معرض للجو",
  "block.minecraft.waxed_weathered_cut_copper": "نحاس مقطع مشمع معرض للجو",
  "block.minecraft.waxed_weathered_cut_copper_slab": "بلاطة نحاس مقطع مشمع معرض للجو",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "درج نحاس مقطع مشمع معرض للجو",
  "block.minecraft.waxed_weathered_lightning_rod": "عصا البرق المشمعة المعرضة للجو",
  "block.minecraft.weathered_chiseled_copper": "نحاس منحوت معرض للجو",
  "block.minecraft.weathered_copper": "نحاس معرض للجو",
  "block.minecraft.weathered_copper_bars": "قضبان نحاسية معرضة للجو",
  "block.minecraft.weathered_copper_bulb": "مصباح نحاسي معرض للجو",
  "block.minecraft.weathered_copper_chain": "سلسلة نحاسية معرضة للجو",
  "block.minecraft.weathered_copper_chest": "صندوق نحاسي معرض للجو",
  "block.minecraft.weathered_copper_door": "باب نحاسي معرض للجو",
  "block.minecraft.weathered_copper_golem_statue": "تمثال رجل نحاسي معرض للجو",
  "block.minecraft.weathered_copper_grate": "شبك نحاسي معرض للجو",
  "block.minecraft.weathered_copper_lantern": "فانوس نحاسي معرض للجو",
  "block.minecraft.weathered_copper_trapdoor": "باب أرضي نحاسي معرض للجو",
  "block.minecraft.weathered_cut_copper": "نحاس مقطع معرض للجو",
  "block.minecraft.weathered_cut_copper_slab": "بلاطة نحاس مقطع معرض للجو",
  "block.minecraft.weathered_cut_copper_stairs": "درج نحاس مقطع معرض للجو",
  "block.minecraft.weathered_lightning_rod": "عصا البرق المعرضة للجو",
  "block.minecraft.weeping_vines": "نبات متسلق متدلي",
  "block.minecraft.weeping_vines_plant": "غرسة النبات المتسلق المتدلي",
  "block.minecraft.wet_sponge": "إسفنج رطب",
  "block.minecraft.wheat": "محاصيل القمح",
  "block.minecraft.white_banner": "راية بيضاء",
  "block.minecraft.white_bed": "سرير أبيض",
  "block.minecraft.white_candle": "شمعة بيضاء",
  "block.minecraft.white_candle_cake": "كعكة مع شمعة بيضاء",
  "block.minecraft.white_carpet": "سجاد أبيض",
  "block.minecraft.white_concrete": "أسمنت أبيض",
  "block.minecraft.white_concrete_powder": "مسحوق أسمنت أبيض",
  "block.minecraft.white_glazed_terracotta": "طين المزجج الأبيض",
  "block.minecraft.white_shulker_box": "صندوق شلكر أبيض",
  "block.minecraft.white_stained_glass": "زجاج ابيض",
  "block.minecraft.white_stained_glass_pane": "لوح زجاجي أبيض",
  "block.minecraft.white_terracotta": "طين النضيج الأبيض",
  "block.minecraft.white_tulip": "توليب أبيض",
  "block.minecraft.white_wool": "صوف أبيض",
  "block.minecraft.wildflowers": "زهور برية",
  "block.minecraft.wither_rose": "زهرة الوذر",
  "block.minecraft.wither_skeleton_skull": "جمجمة الهيكل العظمي الويذر",
  "block.minecraft.wither_skeleton_wall_skull": "جمجمة الهيكل العظمي الويذر حائطية",
  "block.minecraft.yellow_banner": "راية صفراء",
  "block.minecraft.yellow_bed": "سرير أصفر",
  "block.minecraft.yellow_candle": "شمعة صفراء",
  "block.minecraft.yellow_candle_cake": "كعكة مع شمعة صفراء",
  "block.minecraft.yellow_carpet": "سجاد أصفر",
  "block.minecraft.yellow_concrete": "أسمنت أصفر",
  "block.minecraft.yellow_concrete_powder": "مسحوق أسمنت أصفر",
  "block.minecraft.yellow_glazed_terracotta": "طين المزجج الأصفر",
  "block.minecraft.yellow_shulker_box": "صندوق شلكر أصفر",
  "block.minecraft.yellow_stained_glass": "زجاج اصفر",
  "block.minecraft.yellow_stained_glass_pane": "لوح زجاجي أصفر",
  "block.minecraft.yellow_terracotta": "طين النضيج الأصفر",
  "block.minecraft.yellow_wool": "صوف أصفر",
  "block.minecraft.zombie_head": "رأس زومبي",
  "block.minecraft.zombie_wall_head": "رأس زومبي حائطي",
  "item.minecraft.acacia_boat": "قارب السنط",
  "item.minecraft.acacia_chest_boat": "قارب السنط بصندوق",
  "item.minecraft.allay_spawn_egg": "بيضة المساعد الصغير",
  "item.minecraft.amethyst_shard": "شظية جمشت",
  "item.minecraft.angler_pottery_shard": "شظية فخار الصياد",
  "item.minecraft.angler_pottery_sherd": "شظية فخار الصياد",
  "item.minecraft.apple": "تفاحة",
  "item.minecraft.archer_pottery_shard": "شظية فخارا لقواس",
  "item.minecraft.archer_pottery_sherd": "شظية فخار رامي الأسهم",
  "item.minecraft.armadillo_scute": "صفيحة القُنفُش",
  "item.minecraft.armadillo_spawn_egg": "بيضة القُنفُش",
  "item.minecraft.armor_stand": "حامل الدرع",
  "item.minecraft.arms_up_pottery_shard": "ارفع شظية الفخار",
  "item.minecraft.arms_up_pottery_sherd": "شظية فخار الأذرع للأعلى",
  "item.minecraft.arrow": "سهم",
  "item.minecraft.axolotl_bucket": "دلو فيه عفريت ماء",
  "item.minecraft.axolotl_spawn_egg": "بيضة عفريت الماء",
  "item.minecraft.baked_potato": "بطاطس مطبوخة",
  "item.minecraft.bamboo_chest_raft": "طوف من الخيزران مع صندوق",
  "item.minecraft.bamboo_raft": "طوف من الخيزران",
  "item.minecraft.bat_spawn_egg": "بيضة الخفاش",
  "item.minecraft.bee_spawn_egg": "بيضة نحلة",
  "item.minecraft.beef": "لحم بقر نيء",
  "item.minecraft.beetroot": "شمندر",
  "item.minecraft.beetroot_seeds": "بذور الشمندر",
  "item.minecraft.beetroot_soup": "حساء الشمندر",
  "item.minecraft.birch_boat": "قارب البتولا",
  "item.minecraft.birch_chest_boat": "قارب البتولا بصندوق",
  "item.minecraft.black_bundle": "حزمة سوداء",
  "item.minecraft.black_dye": "صبغة سوداء",
  "item.minecraft.black_harness": "هودج أسود",
  "item.minecraft.blade_pottery_shard": "شظية نصل الفخار",
  "item.minecraft.blade_pottery_sherd": "شظية فخار الشفرة",
  "item.minecraft.blaze_powder": "بودرة اللهب",
  "item.minecraft.blaze_rod": "عصا اللهب",
  "item.minecraft.blaze_spawn_egg": "بيضة الملتهب",
  "item.minecraft.blue_bundle": "حزمة زرقاء",
  "item.minecraft.blue_dye": "صبغة زرقاء",
  "item.minecraft.blue_egg": "بيضة زرقاء",
  "item.minecraft.blue_harness": "هودج أزرق",
  "item.minecraft.bogged_spawn_egg": "بيضة المستقِع",
  "item.minecraft.bolt_armor_trim_smithing_template": "قالب الحدادة",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "تصميم الدرع على شكل مسمار",
  "item.minecraft.bone": "عظمة",
  "item.minecraft.bone_meal": "مسحوق العظام",
  "item.minecraft.book": "كتاب",
  "item.minecraft.bordure_indented_banner_pattern": "نمط حد مسنن للراية",
  "item.minecraft.bow": "قوس",
  "item.minecraft.bowl": "زبدية",
  "item.minecraft.bread": "خبز",
  "item.minecraft.breeze_rod": "عصا النسيم",
  "item.minecraft.breeze_spawn_egg": "بيضة النسيم",
  "item.minecraft.brewer_pottery_shard": "شظية فخار التخمير",
  "item.minecraft.brewer_pottery_sherd": "شظية فخار المخمر",
  "item.minecraft.brewing_stand": "منضدة التخمير",
  "item.minecraft.brick": "طوب",
  "item.minecraft.brown_bundle": "حزمة بنية",
  "item.minecraft.brown_dye": "صبغة بنية",
  "item.minecraft.brown_egg": "بيضة بنية",
  "item.minecraft.brown_harness": "هودج بُنِّي",
  "item.minecraft.brush": "فرشاة",
  "item.minecraft.bucket": "دلو",
  "item.minecraft.bundle": "حزمة",
  "item.minecraft.bundle.empty": "فارغ",
  "item.minecraft.bundle.empty.description": "يمكن حمل حزم متنوعة من الأغراض",
  "item.minecraft.bundle.full": "ممتلئ",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "شظية فخار الحرق",
  "item.minecraft.burn_pottery_sherd": "شظية فخار الحرق",
  "item.minecraft.camel_husk_spawn_egg": "بيضة استدعاء الجمل الوحشي",
  "item.minecraft.camel_spawn_egg": "بيضة الجمل",
  "item.minecraft.carrot": "جزرة",
  "item.minecraft.carrot_on_a_stick": "جزرة على عصا",
  "item.minecraft.cat_spawn_egg": "بيضة القطة",
  "item.minecraft.cauldron": "مرجل",
  "item.minecraft.cave_spider_spawn_egg": "بيضة عنكبوت الكهف",
  "item.minecraft.chainmail_boots": "حذاء زردي",
  "item.minecraft.chainmail_chestplate": "صفيحة صدر زردية",
  "item.minecraft.chainmail_helmet": "خوذة زردية",
  "item.minecraft.chainmail_leggings": "سروال زردي",
  "item.minecraft.charcoal": "فحم نباتي",
  "item.minecraft.cherry_boat": "قارب الكرز",
  "item.minecraft.cherry_chest_boat": "قارب الكرز بصندوق",
  "item.minecraft.chest_minecart": "عربة منجم بصندوق",
  "item.minecraft.chicken": "دجاج نيء",
  "item.minecraft.chicken_spawn_egg": "بيضة الدجاجة",
  "item.minecraft.chorus_fruit": "فاكهة الكورس",
  "item.minecraft.clay_ball": "كرة صلصال",
  "item.minecraft.clock": "ساعة",
  "item.minecraft.coal": "فحم",
  "item.minecraft.coast_armor_trim_smithing_template": "قالب الحدادة",
  "item.minecraft.coast_armor_trim_smithing_template.new": "تصميم الدرع على شكل ساحل",
  "item.minecraft.cocoa_beans": "حبوب الكاكاو",
  "item.minecraft.cod": "سمك قد نيء",
  "item.minecraft.cod_bucket": "دلو فيه سمكة القد",
  "item.minecraft.cod_spawn_egg": "بيضة سمكة القد",
  "item.minecraft.command_block_minecart": "عربة منجم مع كتلة الأوامر",
  "item.minecraft.compass": "بوصلة",
  "item.minecraft.cooked_beef": "شريحة لحم",
  "item.minecraft.cooked_chicken": "دجاج مطبوخ",
  "item.minecraft.cooked_cod": "سمك قد مطبوخ",
  "item.minecraft.cooked_mutton": "لحم ضأن مطبوخ",
  "item.minecraft.cooked_porkchop": "ضلع خنزير مطبوخ",
  "item.minecraft.cooked_rabbit": "لحم أرنب مطبوخ",
  "item.minecraft.cooked_salmon": "سلمون مطبوخ",
  "item.minecraft.cookie": "بسكويت",
  "item.minecraft.copper_axe": "فأس نحاسي",
  "item.minecraft.copper_boots": "حذاء نحاسي",
  "item.minecraft.copper_chestplate": "صفيحة صدر نحاسية",
  "item.minecraft.copper_golem_spawn_egg": "بيضة الرجل النحاسي",
  "item.minecraft.copper_helmet": "خوذة نحاسية",
  "item.minecraft.copper_hoe": "معزقة نحاسية",
  "item.minecraft.copper_horse_armor": "درع حصان نحاسي",
  "item.minecraft.copper_ingot": "سبيكة نحاس",
  "item.minecraft.copper_leggings": "سروال نحاسي",
  "item.minecraft.copper_nautilus_armor": "درع نوتيلوس النحاسي",
  "item.minecraft.copper_nugget": "قطعة نحاسية",
  "item.minecraft.copper_pickaxe": "معول نحاسي",
  "item.minecraft.copper_shovel": "مجرفة نحاسية",
  "item.minecraft.copper_spear": "رمح نحاسي",
  "item.minecraft.copper_sword": "سيف نحاسي",
  "item.minecraft.cow_spawn_egg": "بيضة البقرة",
  "item.minecraft.creaking_spawn_egg": "بيضة الصرير",
  "item.minecraft.creeper_banner_pattern": "نمط الراية",
  "item.minecraft.creeper_banner_pattern.desc": "شعار كريبر",
  "item.minecraft.creeper_banner_pattern.new": "نمط شعار كريبر للراية",
  "item.minecraft.creeper_spawn_egg": "بيضة الكريبر",
  "item.minecraft.crossbow": "القوس والنشاب",
  "item.minecraft.crossbow.projectile": "قذيفة:",
  "item.minecraft.crossbow.projectile.multiple": "قذيفة: %s x %s",
  "item.minecraft.crossbow.projectile.single": "قذيفة: %s",
  "item.minecraft.cyan_bundle": "حزمة سماوية",
  "item.minecraft.cyan_dye": "صبغة سماوية",
  "item.minecraft.cyan_harness": "هودج سماوي",
  "item.minecraft.danger_pottery_shard": "شظية فخار الخطر",
  "item.minecraft.danger_pottery_sherd": "شظية فخار الخطر",
  "item.minecraft.dark_oak_boat": "قارب البلوط الداكن",
  "item.minecraft.dark_oak_chest_boat": "قارب البلوط الداكن بصندوق",
  "item.minecraft.debug_stick": "عصا التصحيح",
  "item.minecraft.debug_stick.empty": "%s ليس له أي خصائص",
  "item.minecraft.debug_stick.select": "تم اختيار \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" إلى %s",
  "item.minecraft.diamond": "ألماس",
  "item.minecraft.diamond_axe": "فأس ألماسي",
  "item.minecraft.diamond_boots": "حذاء ألماسي",
  "item.minecraft.diamond_chestplate": "صفيحة صدر ألماسية",
  "item.minecraft.diamond_helmet": "خوذة ألماسية",
  "item.minecraft.diamond_hoe": "معزقة ألماسية",
  "item.minecraft.diamond_horse_armor": "درع حصان ألماسي",
  "item.minecraft.diamond_leggings": "سروال ألماسي",
  "item.minecraft.diamond_nautilus_armor": "درع نوتيلوس الماسي",
  "item.minecraft.diamond_pickaxe": "معول ألماسي",
  "item.minecraft.diamond_shovel": "مجرفة ألماسية",
  "item.minecraft.diamond_spear": "رمح الماس",
  "item.minecraft.diamond_sword": "سيف ألماسي",
  "item.minecraft.disc_fragment_5": "جزء القرص",
  "item.minecraft.disc_fragment_5.desc": "قرص موسيقى - 5",
  "item.minecraft.dolphin_spawn_egg": "بيضة الدلفين",
  "item.minecraft.donkey_spawn_egg": "بيضة الحمار",
  "item.minecraft.dragon_breath": "نفس التنين",
  "item.minecraft.dried_kelp": "عشب بحر المجفف",
  "item.minecraft.drowned_spawn_egg": "بيضة الغارق",
  "item.minecraft.dune_armor_trim_smithing_template": "قالب الحدادة",
  "item.minecraft.dune_armor_trim_smithing_template.new": "تصميم الدرع على شكل تل رملي",
  "item.minecraft.echo_shard": "شظية الصدى",
  "item.minecraft.egg": "بيضة",
  "item.minecraft.elder_guardian_spawn_egg": "بيضة الحارس الأقدم",
  "item.minecraft.elytra": "إليترا",
  "item.minecraft.emerald": "زمرد",
  "item.minecraft.enchanted_book": "كتاب مسحور",
  "item.minecraft.enchanted_golden_apple": "تفاحة ذهبية مسحورة",
  "item.minecraft.end_crystal": "كريستالة الاند",
  "item.minecraft.ender_dragon_spawn_egg": "بيضة تنين الاندر",
  "item.minecraft.ender_eye": "عين الاندر",
  "item.minecraft.ender_pearl": "لؤلؤة الاندر",
  "item.minecraft.enderman_spawn_egg": "بيضة الأندرمان",
  "item.minecraft.endermite_spawn_egg": "بيضة الأندرمايت",
  "item.minecraft.evoker_spawn_egg": "بيضة المستدعي",
  "item.minecraft.experience_bottle": "قنينة السحر",
  "item.minecraft.explorer_pottery_shard": "شظية فخار المستكشف",
  "item.minecraft.explorer_pottery_sherd": "شظية فخار المستكشف",
  "item.minecraft.eye_armor_trim_smithing_template": "قالب الحدادة",
  "item.minecraft.eye_armor_trim_smithing_template.new": "تصميم الدرع على شكل عين",
  "item.minecraft.feather": "ريشة",
  "item.minecraft.fermented_spider_eye": "عين العنكبوت المخمرة",
  "item.minecraft.field_masoned_banner_pattern": "نمط طوب للراية",
  "item.minecraft.filled_map": "خريطة",
  "item.minecraft.fire_charge": "شحنة نارية",
  "item.minecraft.firework_rocket": "صاروخ الألعاب النارية",
  "item.minecraft.firework_rocket.flight": "مدة الطيران:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "نجمة الألعاب النارية",
  "item.minecraft.firework_star.black": "أسود",
  "item.minecraft.firework_star.blue": "أزرق",
  "item.minecraft.firework_star.brown": "بني",
  "item.minecraft.firework_star.custom_color": "مخصص",
  "item.minecraft.firework_star.cyan": "السماوي",
  "item.minecraft.firework_star.fade_to": "تتلاشى الى",
  "item.minecraft.firework_star.flicker": "وميض",
  "item.minecraft.firework_star.gray": "رمادي",
  "item.minecraft.firework_star.green": "أخضر",
  "item.minecraft.firework_star.light_blue": "أزرق فاتح",
  "item.minecraft.firework_star.light_gray": "رمادي فاتح",
  "item.minecraft.firework_star.lime": "ليموني",
  "item.minecraft.firework_star.magenta": "أرجواني",
  "item.minecraft.firework_star.orange": "برتقالي",
  "item.minecraft.firework_star.pink": "وردي",
  "item.minecraft.firework_star.purple": "بنفسجي",
  "item.minecraft.firework_star.red": "أحمر",
  "item.minecraft.firework_star.shape": "شكل غير معروف",
  "item.minecraft.firework_star.shape.burst": "انفجار",
  "item.minecraft.firework_star.shape.creeper": "بشكل كريبر",
  "item.minecraft.firework_star.shape.large_ball": "كرة كبيرة",
  "item.minecraft.firework_star.shape.small_ball": "كرة صغيرة",
  "item.minecraft.firework_star.shape.star": "بشكل نجمة",
  "item.minecraft.firework_star.trail": "أثر",
  "item.minecraft.firework_star.white": "أبيض",
  "item.minecraft.firework_star.yellow": "أصفر",
  "item.minecraft.fishing_rod": "صنارة صيد",
  "item.minecraft.flint": "صوان",
  "item.minecraft.flint_and_steel": "حديد وصوان",
  "item.minecraft.flow_armor_trim_smithing_template": "قالب الحدادة",
  "item.minecraft.flow_armor_trim_smithing_template.new": "تصميم الدرع على شكل التدفق",
  "item.minecraft.flow_banner_pattern": "نمط الراية",
  "item.minecraft.flow_banner_pattern.desc": "تدفق",
  "item.minecraft.flow_banner_pattern.new": "نمط التدفق للراية",
  "item.minecraft.flow_pottery_sherd": "شظية فخار التدفق",
  "item.minecraft.flower_banner_pattern": "نمط الراية",
  "item.minecraft.flower_banner_pattern.desc": "شعار زهرة",
  "item.minecraft.flower_banner_pattern.new": "نمط شعار زهرة للراية",
  "item.minecraft.flower_pot": "وعاء للزهور",
  "item.minecraft.fox_spawn_egg": "بيضة الثعلب",
  "item.minecraft.friend_pottery_shard": "شظية فخار الصديق",
  "item.minecraft.friend_pottery_sherd": "شظية فخار الصديق",
  "item.minecraft.frog_spawn_egg": "بيضة الضفدع",
  "item.minecraft.furnace_minecart": "عربة منجم بفرن",
  "item.minecraft.ghast_spawn_egg": "بيضة الشبح",
  "item.minecraft.ghast_tear": "دمعة الشبح",
  "item.minecraft.glass_bottle": "قارورة زجاج",
  "item.minecraft.glistering_melon_slice": "قطعة بطيخ لامعة",
  "item.minecraft.globe_banner_pattern": "نمط الراية",
  "item.minecraft.globe_banner_pattern.desc": "الكرة الأرضية",
  "item.minecraft.globe_banner_pattern.new": "نمط لائحة الكرة الأرضية",
  "item.minecraft.glow_berries": "توت مُشع",
  "item.minecraft.glow_ink_sac": "كيس حبر متوهج",
  "item.minecraft.glow_item_frame": "إطار أغراض متوهج",
  "item.minecraft.glow_squid_spawn_egg": "بيضة الأخطبوط المضيئ",
  "item.minecraft.glowstone_dust": "مسحوق الحجر المضيء",
  "item.minecraft.goat_horn": "قرن الماعز",
  "item.minecraft.goat_spawn_egg": "بيضة ماعز",
  "item.minecraft.gold_ingot": "سبيكة ذهب",
  "item.minecraft.gold_nugget": "قطعة ذهبية",
  "item.minecraft.golden_apple": "تفاحة ذهبية",
  "item.minecraft.golden_axe": "فأس ذهبي",
  "item.minecraft.golden_boots": "حذاء ذهبي",
  "item.minecraft.golden_carrot": "جزرة ذهبية",
  "item.minecraft.golden_chestplate": "صفيحة صدر ذهبية",
  "item.minecraft.golden_helmet": "خوذة ذهبية",
  "item.minecraft.golden_hoe": "معزقة ذهبية",
  "item.minecraft.golden_horse_armor": "درع حصان ذهبي",
  "item.minecraft.golden_leggings": "سروال ذهبي",
  "item.minecraft.golden_nautilus_armor": "درع نوتيلوس الذهبي",
  "item.minecraft.golden_pickaxe": "معول ذهبي",
  "item.minecraft.golden_shovel": "مجرفة ذهبية",
  "item.minecraft.golden_spear": "رمح ذهبي",
  "item.minecraft.golden_sword": "سيف ذهبي",
  "item.minecraft.gray_bundle": "حزمة رمادية",
  "item.minecraft.gray_dye": "صبغة رمادية",
  "item.minecraft.gray_harness": "هودج رمادي",
  "item.minecraft.green_bundle": "حزمة خضراء",
  "item.minecraft.green_dye": "صبغة خضراء",
  "item.minecraft.green_harness": "هودج أخضر",
  "item.minecraft.guardian_spawn_egg": "بيضة الحارس",
  "item.minecraft.gunpowder": "بارود",
  "item.minecraft.guster_banner_pattern": "نمط الراية",
  "item.minecraft.guster_banner_pattern.desc": "بريق",
  "item.minecraft.guster_banner_pattern.new": "نمط عاصف للراية",
  "item.minecraft.guster_pottery_sherd": "شظية فخار الإعصار",
  "item.minecraft.happy_ghast_spawn_egg": "بيضة استدعاء الغاست السعيد",
  "item.minecraft.harness": "هودج",
  "item.minecraft.heart_of_the_sea": "قلب البحر",
  "item.minecraft.heart_pottery_shard": "شظية فخار القلب",
  "item.minecraft.heart_pottery_sherd": "شظية فخار القلب",
  "item.minecraft.heartbreak_pottery_shard": "شظية فخار الحسرة",
  "item.minecraft.heartbreak_pottery_sherd": "شظية فخار الحسرة",
  "item.minecraft.hoglin_spawn_egg": "بيضة الهوجلن",
  "item.minecraft.honey_bottle": "قارورة عسل",
  "item.minecraft.honeycomb": "قرص عسل",
  "item.minecraft.hopper_minecart": "عربة منجم مع هوبر",
  "item.minecraft.horse_spawn_egg": "بيضة الحصان",
  "item.minecraft.host_armor_trim_smithing_template": "قالب الحدادة",
  "item.minecraft.host_armor_trim_smithing_template.new": "تصميم الدرع على شكل مضيف",
  "item.minecraft.howl_pottery_shard": "شظية فخار العواء",
  "item.minecraft.howl_pottery_sherd": "شظية فخار العواء",
  "item.minecraft.husk_spawn_egg": "بيضة المتقشر",
  "item.minecraft.ink_sac": "كيس حبر",
  "item.minecraft.iron_axe": "فأس حديدي",
  "item.minecraft.iron_boots": "حذاء حديدي",
  "item.minecraft.iron_chestplate": "صفيحة صدر حديدية",
  "item.minecraft.iron_golem_spawn_egg": "بيضة الرجل الحديدي",
  "item.minecraft.iron_helmet": "خوذة حديدية",
  "item.minecraft.iron_hoe": "معزقة حديدية",
  "item.minecraft.iron_horse_armor": "درع حصان حديدي",
  "item.minecraft.iron_ingot": "سبيكة حديد",
  "item.minecraft.iron_leggings": "سروال حديدي",
  "item.minecraft.iron_nautilus_armor": "درع نوتيلوس الحديدي",
  "item.minecraft.iron_nugget": "قطعة حديدية",
  "item.minecraft.iron_pickaxe": "معول حديدي",
  "item.minecraft.iron_shovel": "مجرفة حديدية",
  "item.minecraft.iron_spear": "رمح حديدي",
  "item.minecraft.iron_sword": "سيف حديدي",
  "item.minecraft.item_frame": "إطار الأغراض",
  "item.minecraft.jungle_boat": "قارب الأدغال",
  "item.minecraft.jungle_chest_boat": "قارب الأدغال بصندوق",
  "item.minecraft.knowledge_book": "كتاب المعرفة",
  "item.minecraft.lapis_lazuli": "لازورد",
  "item.minecraft.lava_bucket": "دلو حمم بركانية",
  "item.minecraft.lead": "حبل",
  "item.minecraft.leather": "جلد",
  "item.minecraft.leather_boots": "حذاء جلدي",
  "item.minecraft.leather_chestplate": "سترة جلدية",
  "item.minecraft.leather_helmet": "قبعة جلدية",
  "item.minecraft.leather_horse_armor": "درع حصان جلدي",
  "item.minecraft.leather_leggings": "سروال جلدي",
  "item.minecraft.light_blue_bundle": "حزمة زرقاء فاتحة",
  "item.minecraft.light_blue_dye": "صبغة زرقاء فاتحة",
  "item.minecraft.light_blue_harness": "هودج أزرق فاتح",
  "item.minecraft.light_gray_bundle": "حزمة رمادية فاتحة",
  "item.minecraft.light_gray_dye": "صبغة رمادية فاتحة",
  "item.minecraft.light_gray_harness": "هودج رمادي فاتح",
  "item.minecraft.lime_bundle": "حزمة ليمونية",
  "item.minecraft.lime_dye": "صبغة ليمونية",
  "item.minecraft.lime_harness": "هودج جيري",
  "item.minecraft.lingering_potion": "جرعة باقية",
  "item.minecraft.lingering_potion.effect.awkward": "غاز الجرعة العجيبة",
  "item.minecraft.lingering_potion.effect.empty": "غاز الجرعة الغير قابلة للصنع",
  "item.minecraft.lingering_potion.effect.fire_resistance": "غاز جرعة مقاومة النار",
  "item.minecraft.lingering_potion.effect.harming": "غاز حرعة الإيذاء",
  "item.minecraft.lingering_potion.effect.healing": "غاز جرعة الشفاء",
  "item.minecraft.lingering_potion.effect.infested": "رشه جرعة العدوى",
  "item.minecraft.lingering_potion.effect.invisibility": "غاز جرعة التخفى",
  "item.minecraft.lingering_potion.effect.leaping": "غاز جرعة الوثب",
  "item.minecraft.lingering_potion.effect.levitation": "رشة جرعة الطوفان",
  "item.minecraft.lingering_potion.effect.luck": "رشة جرعة الحظ",
  "item.minecraft.lingering_potion.effect.mundane": "غاز الجرعة الفارغة",
  "item.minecraft.lingering_potion.effect.night_vision": "غاز جرعة الرؤية الليلية",
  "item.minecraft.lingering_potion.effect.oozing": "غاز جرعة النزيز",
  "item.minecraft.lingering_potion.effect.poison": "غاز جرعة السم",
  "item.minecraft.lingering_potion.effect.regeneration": "غاز جرعة تجدد الصحة",
  "item.minecraft.lingering_potion.effect.slow_falling": "جرعة السقوط البطيء الغازية",
  "item.minecraft.lingering_potion.effect.slowness": "غاز جرعة البطء",
  "item.minecraft.lingering_potion.effect.strength": "رشة جرعة القوة",
  "item.minecraft.lingering_potion.effect.swiftness": "غاز جرعة السرعة",
  "item.minecraft.lingering_potion.effect.thick": "غاز الجرعة الكثيفة",
  "item.minecraft.lingering_potion.effect.turtle_master": "جرعة سيد السلاحف الغازية",
  "item.minecraft.lingering_potion.effect.water": "غاز الماء",
  "item.minecraft.lingering_potion.effect.water_breathing": "غاز جرعة التنفس تحت الماء",
  "item.minecraft.lingering_potion.effect.weakness": "رشة جرعة الضعف",
  "item.minecraft.lingering_potion.effect.weaving": "غاز جرعة العالقة",
  "item.minecraft.lingering_potion.effect.wind_charged": "غاز جرعة شحن الرياح",
  "item.minecraft.llama_spawn_egg": "بيضة اللاما",
  "item.minecraft.lodestone_compass": "بوصلة حجر المغناطيس",
  "item.minecraft.mace": "صولجان",
  "item.minecraft.magenta_bundle": "حزمة أرجوانية",
  "item.minecraft.magenta_dye": "صبغة أرجوانية",
  "item.minecraft.magenta_harness": "هودج أرجواني",
  "item.minecraft.magma_cream": "كريم الصهارة",
  "item.minecraft.magma_cube_spawn_egg": "بيضة مكعب الصهارة",
  "item.minecraft.mangrove_boat": "قارب المانغروف",
  "item.minecraft.mangrove_chest_boat": "قارب المانغروف بصندوق",
  "item.minecraft.map": "خريطة فارغة",
  "item.minecraft.melon_seeds": "بذور البطيخ",
  "item.minecraft.melon_slice": "قطعة بطيخ",
  "item.minecraft.milk_bucket": "دلو حليب",
  "item.minecraft.minecart": "عربة منجم",
  "item.minecraft.miner_pottery_shard": "شظية فخار عامل المنجم",
  "item.minecraft.miner_pottery_sherd": "شظية فخار عامل المنجم",
  "item.minecraft.mojang_banner_pattern": "نمط الراية",
  "item.minecraft.mojang_banner_pattern.desc": "شيء",
  "item.minecraft.mojang_banner_pattern.new": "نمط لائحة شيء ما",
  "item.minecraft.mooshroom_spawn_egg": "بيضة بقرة الفطر",
  "item.minecraft.mourner_pottery_shard": "شظية فخار الحداد",
  "item.minecraft.mourner_pottery_sherd": "شظية فخار الحداد",
  "item.minecraft.mule_spawn_egg": "بيضة البغل",
  "item.minecraft.mushroom_stew": "حساء الفطر",
  "item.minecraft.music_disc_11": "قرص موسيقى",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "أسطوانة أغاني",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "قرص موسيقى",
  "item.minecraft.music_disc_5.desc": "ساميول ابيرغ - 5",
  "item.minecraft.music_disc_blocks": "أسطوانة موسيقى",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "أسطوانة موسيقى",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "أسطوانة موسيقى",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "قرص موسيقى",
  "item.minecraft.music_disc_creator.desc": "لينا رين - Creator",
  "item.minecraft.music_disc_creator_music_box": "قرص موسيقى",
  "item.minecraft.music_disc_creator_music_box.desc": "لينا رين - Creator (Music Box)",
  "item.minecraft.music_disc_far": "أسطوانة موسيقى",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "قرص الموسيقى",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "قرص موسيقى",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "قرص موسيقى",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "قرص موسيقى",
  "item.minecraft.music_disc_otherside.desc": "لَينا رَين - otherside",
  "item.minecraft.music_disc_pigstep": "قرص موسيقى",
  "item.minecraft.music_disc_pigstep.desc": "لَينا رَين - Pigstep",
  "item.minecraft.music_disc_precipice": "قرص الموسيقى",
  "item.minecraft.music_disc_precipice.desc": "آرون شيروف - Precipice",
  "item.minecraft.music_disc_relic": "قرص الموسيقى",
  "item.minecraft.music_disc_relic.desc": "آرون شيروف - Relic",
  "item.minecraft.music_disc_stal": "قرص موسيقى",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "قرص موسيقى",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "قرص الموسيقى",
  "item.minecraft.music_disc_tears.desc": "آموس رودي - Tears",
  "item.minecraft.music_disc_wait": "قرص موسيقى",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "قرص موسيقى",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "لحم ضأن نيء",
  "item.minecraft.name_tag": "علامة اسم",
  "item.minecraft.nautilus_shell": "صدفة النوتي",
  "item.minecraft.nautilus_spawn_egg": "بيضة استدعاء النوتيلوس",
  "item.minecraft.nether_brick": "طوب النذر",
  "item.minecraft.nether_star": "نجمة النذر",
  "item.minecraft.nether_wart": "ثؤلول العالم السفلي",
  "item.minecraft.netherite_axe": "فأس نذرايت",
  "item.minecraft.netherite_boots": "حذاء نذرايت",
  "item.minecraft.netherite_chestplate": "صفيحة صدر نذرايت",
  "item.minecraft.netherite_helmet": "خوذة نذرايت",
  "item.minecraft.netherite_hoe": "معزقة نذرايت",
  "item.minecraft.netherite_horse_armor": "درع حصان نذريات",
  "item.minecraft.netherite_ingot": "سبيكة نذرايت",
  "item.minecraft.netherite_leggings": "سروال نذرايت",
  "item.minecraft.netherite_nautilus_armor": "درع نوتيلوس من النذرايت",
  "item.minecraft.netherite_pickaxe": "معول نذرايت",
  "item.minecraft.netherite_scrap": "فتات نذرايت",
  "item.minecraft.netherite_shovel": "مجرفة نذرايت",
  "item.minecraft.netherite_spear": "رمح نذرايت",
  "item.minecraft.netherite_sword": "سيف نذرايت",
  "item.minecraft.netherite_upgrade_smithing_template": "قالب الحدادة",
  "item.minecraft.netherite_upgrade_smithing_template.new": "تطوير نذرايت",
  "item.minecraft.oak_boat": "قارب البلوط",
  "item.minecraft.oak_chest_boat": "قارب البلوط بصندوق",
  "item.minecraft.ocelot_spawn_egg": "بيضة القط البري",
  "item.minecraft.ominous_bottle": "زجاجة مشؤومة",
  "item.minecraft.ominous_trial_key": "مفتاح الاختبار المشؤوم",
  "item.minecraft.orange_bundle": "حزمة برتقالية",
  "item.minecraft.orange_dye": "صبغة برتقالية",
  "item.minecraft.orange_harness": "هودج برتقالي",
  "item.minecraft.painting": "لوحة",
  "item.minecraft.pale_oak_boat": "قارب البلوط الشاحب",
  "item.minecraft.pale_oak_chest_boat": "قارب البلوط الشاحب بصندوق",
  "item.minecraft.panda_spawn_egg": "بيضة الباندا",
  "item.minecraft.paper": "ورقة",
  "item.minecraft.parched_spawn_egg": "بيضة استدعاء الكائن العطشان",
  "item.minecraft.parrot_spawn_egg": "بيضة الببغاء",
  "item.minecraft.phantom_membrane": "غشاء الطيف",
  "item.minecraft.phantom_spawn_egg": "بيضة الطيف",
  "item.minecraft.pig_spawn_egg": "بيضة الخنزير",
  "item.minecraft.piglin_banner_pattern": "نمط الراية",
  "item.minecraft.piglin_banner_pattern.desc": "أنف",
  "item.minecraft.piglin_banner_pattern.new": "نمط الأنف للراية",
  "item.minecraft.piglin_brute_spawn_egg": "بيضة الخنزير المحارب الغاشم",
  "item.minecraft.piglin_spawn_egg": "بيضة البيجلن",
  "item.minecraft.pillager_spawn_egg": "بيضة الناهب",
  "item.minecraft.pink_bundle": "حزمة وردية",
  "item.minecraft.pink_dye": "صبغة وردية",
  "item.minecraft.pink_harness": "هودج وردي",
  "item.minecraft.pitcher_plant": "جرة النبات",
  "item.minecraft.pitcher_pod": "تحت الجرة",
  "item.minecraft.plenty_pottery_shard": "شظية فخار الكثرة",
  "item.minecraft.plenty_pottery_sherd": "شظية فخار الكثرة",
  "item.minecraft.poisonous_potato": "بطاطا سامة",
  "item.minecraft.polar_bear_spawn_egg": "بيضة الدب القطبي",
  "item.minecraft.popped_chorus_fruit": "فاكهة الكورس المفرقعة",
  "item.minecraft.porkchop": "ضلع خنزير نيء",
  "item.minecraft.potato": "بطاطس",
  "item.minecraft.potion": "جرعة",
  "item.minecraft.potion.effect.awkward": "الجرعة العجيبة",
  "item.minecraft.potion.effect.empty": "جرعة غير قابلة للصناعة",
  "item.minecraft.potion.effect.fire_resistance": "جرعة مقاومة النار",
  "item.minecraft.potion.effect.harming": "جرعة الإيذاء",
  "item.minecraft.potion.effect.healing": "جرعة العلاج",
  "item.minecraft.potion.effect.infested": "جرعة العدوى",
  "item.minecraft.potion.effect.invisibility": "جرعة الإخفاء",
  "item.minecraft.potion.effect.leaping": "جرعة الوثب",
  "item.minecraft.potion.effect.levitation": "جرعة الطوفان",
  "item.minecraft.potion.effect.luck": "جرعة الحظ",
  "item.minecraft.potion.effect.mundane": "جرعة فارغة",
  "item.minecraft.potion.effect.night_vision": "جرعة الرؤية الليلية",
  "item.minecraft.potion.effect.oozing": "جرعة النزيز",
  "item.minecraft.potion.effect.poison": "جرعة السم",
  "item.minecraft.potion.effect.regeneration": "جرعة تجدد الصحة",
  "item.minecraft.potion.effect.slow_falling": "جرعة السقوط البطيء",
  "item.minecraft.potion.effect.slowness": "جرعة البطء",
  "item.minecraft.potion.effect.strength": "جرعة القوة",
  "item.minecraft.potion.effect.swiftness": "جرعة السرعة",
  "item.minecraft.potion.effect.thick": "جرعة كثيفة",
  "item.minecraft.potion.effect.turtle_master": "جرعة سيد السلاحف",
  "item.minecraft.potion.effect.water": "قارورة ماء",
  "item.minecraft.potion.effect.water_breathing": "جرعة التنفس في الماء",
  "item.minecraft.potion.effect.weakness": "جرعة الضعف",
  "item.minecraft.potion.effect.weaving": "جرعة النسيج",
  "item.minecraft.potion.effect.wind_charged": "جرعة شحن الرياح",
  "item.minecraft.pottery_shard_archer": "شظية فخار رامي السهام",
  "item.minecraft.pottery_shard_arms_up": "شظية فخار الأذرع للأعلى",
  "item.minecraft.pottery_shard_prize": "شظية فخار الوسام",
  "item.minecraft.pottery_shard_skull": "شظية فخار الجمجمة",
  "item.minecraft.powder_snow_bucket": "دلو مسحوق الثلج",
  "item.minecraft.prismarine_crystals": "بلورات البرسمارين",
  "item.minecraft.prismarine_shard": "قشرة برسمارين",
  "item.minecraft.prize_pottery_shard": "شظية فخار الوسام",
  "item.minecraft.prize_pottery_sherd": "شظية فخار المكافأة",
  "item.minecraft.pufferfish": "سمكة منتفخة",
  "item.minecraft.pufferfish_bucket": "دلو فيه سمكة منتفخة",
  "item.minecraft.pufferfish_spawn_egg": "بيضة السمكة المنتفخة",
  "item.minecraft.pumpkin_pie": "فطيرة يقطين",
  "item.minecraft.pumpkin_seeds": "بذور اليقطين",
  "item.minecraft.purple_bundle": "حزمة بنفسجية",
  "item.minecraft.purple_dye": "صبغة بنفسجية",
  "item.minecraft.purple_harness": "هودج بنفسجي",
  "item.minecraft.quartz": "كوارتز النذر",
  "item.minecraft.rabbit": "أرنب نيء",
  "item.minecraft.rabbit_foot": "رجل أرنب",
  "item.minecraft.rabbit_hide": "جلد أرنب",
  "item.minecraft.rabbit_spawn_egg": "بيضة الأرنب",
  "item.minecraft.rabbit_stew": "حساء الأرنب",
  "item.minecraft.raiser_armor_trim_smithing_template": "قالب الحدادة",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "تصميم الدرع على شكل رافع",
  "item.minecraft.ravager_spawn_egg": "بيضة المدمر",
  "item.minecraft.raw_copper": "نحاس خام",
  "item.minecraft.raw_gold": "ذهب خام",
  "item.minecraft.raw_iron": "حديد خام",
  "item.minecraft.recovery_compass": "بوصلة الاستعادة",
  "item.minecraft.red_bundle": "حزمة حمراء",
  "item.minecraft.red_dye": "صبغة حمراء",
  "item.minecraft.red_harness": "هودج أحمر",
  "item.minecraft.redstone": "مسحوق الريدستون",
  "item.minecraft.resin_brick": "طوب الراتنج",
  "item.minecraft.resin_clump": "مجموعة الراتنج",
  "item.minecraft.rib_armor_trim_smithing_template": "قالب الحدادة",
  "item.minecraft.rib_armor_trim_smithing_template.new": "تصميم الدرع على شكل ضلوع",
  "item.minecraft.rotten_flesh": "لحم فاسد",
  "item.minecraft.saddle": "سرج",
  "item.minecraft.salmon": "سلمون نيء",
  "item.minecraft.salmon_bucket": "دلو فيه سمكة السلمون",
  "item.minecraft.salmon_spawn_egg": "بيضة سمكة السلمون",
  "item.minecraft.scrape_pottery_sherd": "كشط شظية فخار",
  "item.minecraft.scute": "قشرة",
  "item.minecraft.sentry_armor_trim_smithing_template": "قالب الحدادة",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "تصميم الدرع على شكل خفير",
  "item.minecraft.shaper_armor_trim_smithing_template": "قالب الحدادة",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "تصميم الدرع على شكل مشكل",
  "item.minecraft.sheaf_pottery_shard": "شظية فخار الحزمة",
  "item.minecraft.sheaf_pottery_sherd": "شظية فخار الربطة",
  "item.minecraft.shears": "مقص الجز",
  "item.minecraft.sheep_spawn_egg": "بيضة الخروف",
  "item.minecraft.shelter_pottery_shard": "شظية فخار المأوى",
  "item.minecraft.shelter_pottery_sherd": "شظية فخار المأوى",
  "item.minecraft.shield": "درع",
  "item.minecraft.shield.black": "درع أسود",
  "item.minecraft.shield.blue": "درع أزرق",
  "item.minecraft.shield.brown": "درع بني",
  "item.minecraft.shield.cyan": "درع سماوي",
  "item.minecraft.shield.gray": "درع رمادي",
  "item.minecraft.shield.green": "درع أخضر",
  "item.minecraft.shield.light_blue": "درع أزرق فاتح",
  "item.minecraft.shield.light_gray": "درع رمادي فاتح",
  "item.minecraft.shield.lime": "درع ليموني",
  "item.minecraft.shield.magenta": "درع أرجواني",
  "item.minecraft.shield.orange": "درع برتقالي",
  "item.minecraft.shield.pink": "درع وردي",
  "item.minecraft.shield.purple": "درع بنفسجي",
  "item.minecraft.shield.red": "درس أحمر",
  "item.minecraft.shield.white": "درع أبيض",
  "item.minecraft.shield.yellow": "درع أصفر",
  "item.minecraft.shulker_shell": "صدفة الشلكر",
  "item.minecraft.shulker_spawn_egg": "بيضة توليد صدفة النهاية",
  "item.minecraft.sign": "لافتة",
  "item.minecraft.silence_armor_trim_smithing_template": "قالب الحدادة",
  "item.minecraft.silence_armor_trim_smithing_template.new": "تصميم الدرع على شكل الصمت",
  "item.minecraft.silverfish_spawn_egg": "بيضة الدُّمْروصة",
  "item.minecraft.skeleton_horse_spawn_egg": "بيضة الحصان العظمي",
  "item.minecraft.skeleton_spawn_egg": "بيضة الهيكل العظمي",
  "item.minecraft.skull_banner_pattern": "نمط الراية",
  "item.minecraft.skull_banner_pattern.desc": "شعار جمجمة",
  "item.minecraft.skull_banner_pattern.new": "نمط شعار جمجمة للراية",
  "item.minecraft.skull_pottery_shard": "شظية فخار الجمجمة",
  "item.minecraft.skull_pottery_sherd": "شظية فخار الجمجمة",
  "item.minecraft.slime_ball": "كرة لزجة",
  "item.minecraft.slime_spawn_egg": "بيضة الوحش اللازج",
  "item.minecraft.smithing_template": "قالب الحدادة",
  "item.minecraft.smithing_template.applies_to": "تنطبق على:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "اضف سبيكة أو بلورة",
  "item.minecraft.smithing_template.armor_trim.applies_to": "درع",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "اضف قطعة من درع",
  "item.minecraft.smithing_template.armor_trim.ingredients": "سبائك وبلورات",
  "item.minecraft.smithing_template.ingredients": "مكونات:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "إضافة سبيكة النذرايت",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "معِدّات ماسية",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "إضافة ماس, سلاح, أو أداة",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "السبيكة السفلية",
  "item.minecraft.smithing_template.upgrade": "ترقية: ",
  "item.minecraft.sniffer_spawn_egg": "بيضة توليد الشمام",
  "item.minecraft.snort_pottery_shard": "شظية فخار الشخير",
  "item.minecraft.snort_pottery_sherd": "شظية فخار الشخير",
  "item.minecraft.snout_armor_trim_smithing_template": "قالب الحدادة",
  "item.minecraft.snout_armor_trim_smithing_template.new": "تصميم الدرع على شكل أنف",
  "item.minecraft.snow_golem_spawn_egg": "بيضة الرجل الثلجي",
  "item.minecraft.snowball": "كرة ثلج",
  "item.minecraft.spectral_arrow": "سهم طيفي",
  "item.minecraft.spider_eye": "عين العنكبوت",
  "item.minecraft.spider_spawn_egg": "بيضة العنكبوت",
  "item.minecraft.spire_armor_trim_smithing_template": "قالب الحدادة",
  "item.minecraft.spire_armor_trim_smithing_template.new": "تصميم الدرع على شكل برج",
  "item.minecraft.splash_potion": "جرعة رش",
  "item.minecraft.splash_potion.effect.awkward": "رشة الجرعة العجيبة",
  "item.minecraft.splash_potion.effect.empty": "رشة الجرعة الغير قابلة للصنع",
  "item.minecraft.splash_potion.effect.fire_resistance": "رشة جرعة مقاومة النار",
  "item.minecraft.splash_potion.effect.harming": "رشة جرعة الإيذاء",
  "item.minecraft.splash_potion.effect.healing": "رشة جرعة العلاج",
  "item.minecraft.splash_potion.effect.infested": "رشه جرعة العدوى",
  "item.minecraft.splash_potion.effect.invisibility": "رشة جرعة التخفى",
  "item.minecraft.splash_potion.effect.leaping": "رشة جرعة الوثب",
  "item.minecraft.splash_potion.effect.levitation": "رشة جرعة الطوفان",
  "item.minecraft.splash_potion.effect.luck": "رشة جرعة الحظ",
  "item.minecraft.splash_potion.effect.mundane": "رشة الجرعة الفارغة",
  "item.minecraft.splash_potion.effect.night_vision": "رشة جرعة الروية الليلية",
  "item.minecraft.splash_potion.effect.oozing": "رشة جرعة النزيز",
  "item.minecraft.splash_potion.effect.poison": "رشة جرعة السم",
  "item.minecraft.splash_potion.effect.regeneration": "رشة جرعة تجدد الصحة",
  "item.minecraft.splash_potion.effect.slow_falling": "رشة جرعة السقوط البطيء",
  "item.minecraft.splash_potion.effect.slowness": "رشة سرعة البطء",
  "item.minecraft.splash_potion.effect.strength": "رشة جرعة القوة",
  "item.minecraft.splash_potion.effect.swiftness": "رشة جرعة السرعة",
  "item.minecraft.splash_potion.effect.thick": "رشة الجرعة الكثيفة",
  "item.minecraft.splash_potion.effect.turtle_master": "رشة جرعة سيد السلاحف",
  "item.minecraft.splash_potion.effect.water": "رشة الماء",
  "item.minecraft.splash_potion.effect.water_breathing": "رشة سرعة التنفس فى الماء",
  "item.minecraft.splash_potion.effect.weakness": "رشة جرعة الضعف",
  "item.minecraft.splash_potion.effect.weaving": "رشة جرعة النسيج",
  "item.minecraft.splash_potion.effect.wind_charged": "رشه جرعة شحن الرياح",
  "item.minecraft.spruce_boat": "قارب التنوب",
  "item.minecraft.spruce_chest_boat": "قارب التنوب بصندوق",
  "item.minecraft.spyglass": "منظار",
  "item.minecraft.squid_spawn_egg": "بيضة الأخطبوط",
  "item.minecraft.stick": "عصا",
  "item.minecraft.stone_axe": "فأس حجري",
  "item.minecraft.stone_hoe": "معزقة حجرية",
  "item.minecraft.stone_pickaxe": "معول حجري",
  "item.minecraft.stone_shovel": "مجرفة حجرية",
  "item.minecraft.stone_spear": "رمح حجري",
  "item.minecraft.stone_sword": "سيف حجري",
  "item.minecraft.stray_spawn_egg": "بيضة الضال",
  "item.minecraft.strider_spawn_egg": "بيضة توليد السترايدر",
  "item.minecraft.string": "خيط",
  "item.minecraft.sugar": "سكر",
  "item.minecraft.suspicious_stew": "حساء مريب",
  "item.minecraft.sweet_berries": "التوت الحلو",
  "item.minecraft.tadpole_bucket": "دلو فيه شرغوف",
  "item.minecraft.tadpole_spawn_egg": "بيضة الشرغوف",
  "item.minecraft.tide_armor_trim_smithing_template": "قالب الحدادة",
  "item.minecraft.tide_armor_trim_smithing_template.new": "تصميم الدرع على شكل موجة",
  "item.minecraft.tipped_arrow": "سهم مغموس",
  "item.minecraft.tipped_arrow.effect.awkward": "سهم مسحور",
  "item.minecraft.tipped_arrow.effect.empty": "سهم مطلي لا يمكن صنعه",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "سهم مقاومة النار",
  "item.minecraft.tipped_arrow.effect.harming": "سهم الإيذاء",
  "item.minecraft.tipped_arrow.effect.healing": "سهم الشفاء",
  "item.minecraft.tipped_arrow.effect.infested": "سهم العدوى",
  "item.minecraft.tipped_arrow.effect.invisibility": "سهم الاختفاء",
  "item.minecraft.tipped_arrow.effect.leaping": "سهم الوثب",
  "item.minecraft.tipped_arrow.effect.levitation": "سهم الطوف",
  "item.minecraft.tipped_arrow.effect.luck": "سهم الحظ",
  "item.minecraft.tipped_arrow.effect.mundane": "سهم مسحور",
  "item.minecraft.tipped_arrow.effect.night_vision": "سهم الرؤية الليلية",
  "item.minecraft.tipped_arrow.effect.oozing": "سهم النزه",
  "item.minecraft.tipped_arrow.effect.poison": "سهم السم",
  "item.minecraft.tipped_arrow.effect.regeneration": "سهم تجدد الصحة",
  "item.minecraft.tipped_arrow.effect.slow_falling": "سهم السقوط البطيء",
  "item.minecraft.tipped_arrow.effect.slowness": "سهم البطء",
  "item.minecraft.tipped_arrow.effect.strength": "سهم القوة",
  "item.minecraft.tipped_arrow.effect.swiftness": "سهم السرعة",
  "item.minecraft.tipped_arrow.effect.thick": "سهم مسحور",
  "item.minecraft.tipped_arrow.effect.turtle_master": "سهم سيد السلاحف",
  "item.minecraft.tipped_arrow.effect.water": "سهم الرش",
  "item.minecraft.tipped_arrow.effect.water_breathing": "سهم التنفس تحت الماء",
  "item.minecraft.tipped_arrow.effect.weakness": "سهم الضعف",
  "item.minecraft.tipped_arrow.effect.weaving": "سهم النسيج",
  "item.minecraft.tipped_arrow.effect.wind_charged": "سهم شحن الرياح",
  "item.minecraft.tnt_minecart": "عربة منجم مع ديناميت",
  "item.minecraft.torchflower_seeds": "بذور وردة الشعلة",
  "item.minecraft.totem_of_undying": "تميمة الخلود",
  "item.minecraft.trader_llama_spawn_egg": "بيضة توليد لاما التاجر",
  "item.minecraft.trial_key": "مفتاح الاختبار",
  "item.minecraft.trident": "رمح ثلاثي",
  "item.minecraft.tropical_fish": "سمكة استوائية",
  "item.minecraft.tropical_fish_bucket": "دلو فيه سمكة استوائية",
  "item.minecraft.tropical_fish_spawn_egg": "بيضة السمكة الإستوائية",
  "item.minecraft.turtle_helmet": "صدفة سلحفاة",
  "item.minecraft.turtle_scute": "قشرة السلحفاة",
  "item.minecraft.turtle_spawn_egg": "بيضة السلحفاة",
  "item.minecraft.vex_armor_trim_smithing_template": "قالب الحدادة",
  "item.minecraft.vex_armor_trim_smithing_template.new": "تصميم الدرع على شكل المغيظ",
  "item.minecraft.vex_spawn_egg": "بيضة المغيظ",
  "item.minecraft.villager_spawn_egg": "بيضة القروي",
  "item.minecraft.vindicator_spawn_egg": "بيضة المحاسب",
  "item.minecraft.wandering_trader_spawn_egg": "بيضة توليد البائع المتجول",
  "item.minecraft.ward_armor_trim_smithing_template": "قالب الحدادة",
  "item.minecraft.ward_armor_trim_smithing_template.new": "تصميم الدرع على شكل حارس",
  "item.minecraft.warden_spawn_egg": "بيضة حارس الظلام",
  "item.minecraft.warped_fungus_on_a_stick": "فطر عجيب على عصا",
  "item.minecraft.water_bucket": "دلو ماء",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "قالب الحدادة",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "تصميم الدرع على شكل مرشد طريق",
  "item.minecraft.wheat": "قمح",
  "item.minecraft.wheat_seeds": "بذور القمح",
  "item.minecraft.white_bundle": "حزمة بيضاء",
  "item.minecraft.white_dye": "صبغة بيضاء",
  "item.minecraft.white_harness": "هودج أبيض",
  "item.minecraft.wild_armor_trim_smithing_template": "قالب الحدادة",
  "item.minecraft.wild_armor_trim_smithing_template.new": "تصميم الدرع على شكل البرية",
  "item.minecraft.wind_charge": "شحنة الرياح",
  "item.minecraft.witch_spawn_egg": "بيضة الساحرة",
  "item.minecraft.wither_skeleton_spawn_egg": "بيضة الهيكل الفحمي",
  "item.minecraft.wither_spawn_egg": "بيضة رئيس الذبل",
  "item.minecraft.wolf_armor": "دروع الذئب",
  "item.minecraft.wolf_spawn_egg": "بيضة الذئب",
  "item.minecraft.wooden_axe": "فأس خشبي",
  "item.minecraft.wooden_hoe": "معزقة خشبية",
  "item.minecraft.wooden_pickaxe": "معول خشبي",
  "item.minecraft.wooden_shovel": "مجرفة خشبية",
  "item.minecraft.wooden_spear": "رمح خشبي",
  "item.minecraft.wooden_sword": "سيف خشبي",
  "item.minecraft.writable_book": "كتاب و ريشة",
  "item.minecraft.written_book": "كتاب مكتوب",
  "item.minecraft.yellow_bundle": "حزمة صفراء",
  "item.minecraft.yellow_dye": "صبغة صفراء",
  "item.minecraft.yellow_harness": "هودج أصفر",
  "item.minecraft.zoglin_spawn_egg": "بيضة الزوجلين",
  "item.minecraft.zombie_horse_spawn_egg": "بيضة الخيل الزومبي",
  "item.minecraft.zombie_nautilus_spawn_egg": "بيضة استدعاء نوتيلوس الزومبي",
  "item.minecraft.zombie_spawn_egg": "بيضة الزومبي",
  "item.minecraft.zombie_villager_spawn_egg": "بيضة الزومبي القروي",
  "item.minecraft.zombified_piglin_spawn_egg": "بيضة الخنزير الزومبي"
}
export const ar_sa = items; 
